// Simple translations file with a flatter structure
// Each key appears only once with languages nested under it

export default {
  // Common UI elements
  cancel: {
    en: 'Cancel',
    ar: 'إلغاء',
    heb: 'ביטול',
    ru: 'Отмена',
  },

  // Authentication related
  resend: {
    en: 'Resend',
    ar: 'إعادة إرسال',
    heb: 'שלח שוב',
    ru: 'Отправить повторно',
  },

  didntRecieve: {
    en: "Didn't get the code?",
    ar: 'لم تستلم الرمز؟',
    heb: 'לא קיבלת את הקוד?',
    ru: 'Не получили код?',
  },

  resendIn: {
    en: 'Resend in',
    ar: 'إعادة الإرسال في',
    heb: 'שלח שוב בעוד',
    ru: 'Отправить повторно через',
  },

  sms: {
    en: 'SMS',
    ar: 'رسالة نصية',
    heb: 'SMS',
    ru: 'СМС',
  },

  whatsappAuth: {
    en: 'WhatsApp',
    ar: 'واتساب',
    heb: 'וואטסאפ',
    ru: 'WhatsApp',
  },

  failedToVerifyWhatsApp: {
    en: 'Failed to verify WhatsApp code. Please try again.',
    ar: 'فشل التحقق من رمز واتساب. يرجى المحاولة مرة أخرى.',
    heb: 'אימות קוד וואטסאפ נכשל. אנא נסה שוב.',
    ru: 'Не удалось проверить код WhatsApp. Пожалуйста, попробуйте снова.',
  },

  selectAuthMethod: {
    en: 'Select authentication method',
    ar: 'اختر طريقة المصادقة',
    heb: 'בחר שיטת אימות',
    ru: 'Выберите метод аутентификации',
  },

  // Archive functionality
  archive: {
    en: 'Archive',
    ar: 'أرشفة',
    heb: 'ארכיון',
    ru: 'Архив',
  },

  unarchive: {
    en: 'Restore',
    ar: 'إلغاء الأرشفة',
    heb: 'הוצא מארכיון',
    ru: 'Восстановить',
  },

  actions: {
    en: 'Actions',
    ar: 'إجراءات',
    heb: 'פעולות',
    ru: 'Действия',
  },

  // Bulk cancellation
  bulkCancel: {
    en: 'Cancel appointments',
    ar: 'إلغاء مواعيد',
    heb: 'ביטול תורים',
    ru: 'Отменить записи',
  },

  bulkCancelTitle: {
    en: 'Cancel All Appointments',
    ar: 'إلغاء جميع المواعيد',
    heb: 'ביטול כל התורים',
    ru: 'Отменить все встречи',
  },

  confirmAction: {
    en: 'Confirm Action',
    ar: 'تأكيد الإجراء',
    heb: 'אשר פעולה',
    ru: 'Подтвердить действие',
  },

  areYouSureCancelAllOn: {
    en: 'Are you sure you want to cancel all the appointments on',
    ar: 'هل أنت متأكد من إلغاء جميع المواعيد في',
    heb: 'האם אתה בטוח שברצונך לבטל את כל התורים ביום',
    ru: 'Вы уверены, что хотите отменить все встречи на',
  },

  areYouSureCancelAllBetween: {
    en: 'Are you sure you want to cancel all the appointments between',
    ar: 'هل أنت متأكد من إلغاء جميع المواعيد بين',
    heb: 'האם אתה בטוח שברצונך לבטל את כל התורים בין',
    ru: 'Вы уверены, что хотите отменить все встречи между',
  },

  and: {
    en: 'and',
    ar: 'و',
    heb: 'ו',
    ru: 'и',
  },

  for: {
    en: 'for',
    ar: 'لـ',
    heb: 'עבור',
    ru: 'для',
  },

  bulkCancelDescription: {
    en: 'Are you sure you want to cancel all appointments for this day and staff member?',
    ar: 'هل أنت متأكد من إلغاء جميع المواعيد لهذا اليوم وعضو الفريق؟',
    heb: 'האם אתה בטוח שברצונך לבטל את כל התורים עבור היום הזה ואיש הצוות?',
    ru: 'Вы уверены, что хотите отменить все встречи на этот день для этого сотрудника?',
  },

  appointmentsToCancel: {
    en: 'Appointments to Cancel',
    ar: 'المواعيد المراد إلغاؤها',
    heb: 'תורים לביטול',
    ru: 'Встречи для отмены',
  },

  noAppointmentsToCancel: {
    en: 'No appointments found for the selected day and staff member.',
    ar: 'لم يتم العثور على مواعيد لليوم المحدد وعضو الفريق.',
    heb: 'לא נמצאו תורים עבור היום הנבחר ואיש הצוות.',
    ru: 'Встречи не найдены для выбранного дня и сотрудника.',
  },

  staff: {
    en: 'Staff Member',
    ar: 'عضو الفريق',
    heb: 'איש צוות',
    ru: 'Сотрудник',
  },

  cancelling: {
    en: 'Cancelling...',
    ar: 'جاري الإلغاء...',
    heb: 'מבטل...',
    ru: 'Отменяется...',
  },
  showingArchived: {
    en: 'archived',
    ar: 'الارشيف',
    heb: 'ארכיון',
    ru: 'архив',
  },

  // Date range picker translations
  dateRange: {
    en: 'Date Range',
    ar: 'نطاق التاريخ',
    heb: 'טווח תאריכים',
    ru: 'Диапазон дат',
  },

  selectStartDate: {
    en: 'Select start date',
    ar: 'اختر تاريخ البداية',
    heb: 'בחר תאריך התחלה',
    ru: 'Выберите дату начала',
  },

  selectEndDate: {
    en: 'Select end date',
    ar: 'اختر تاريخ النهاية',
    heb: 'בחר תאריך סיום',
    ru: 'Выберите дату окончания',
  },

  selectedRange: {
    en: 'Selected range',
    ar: 'النطاق المحدد',
    heb: 'טווח נבחר',
    ru: 'Выбранный диапазон',
  },

  startDate: {
    en: 'Start Date',
    ar: 'تاريخ البداية',
    heb: 'תאריך התחלה',
    ru: 'Дата начала',
  },

  endDate: {
    en: 'End Date',
    ar: 'تاريخ النهاية',
    heb: 'תאריך סיום',
    ru: 'Дата окончания',
  },

  noAppointmentsInRange: {
    en: 'No appointments found in the selected date range for this staff member.',
    ar: 'لم يتم العثور على مواعيد في النطاق الزمني المحدد لعضو الفريق هذا.',
    heb: 'לא נמצאו תורים בטווח התאריכים הנבחר עבור איש הצוות הזה.',
    ru: 'В выбранном диапазоне дат для этого сотрудника встречи не найдены.',
  },

  closedDayAppointmentsWarningTitle: {
    en: 'Appointments on selected dates',
    ar: 'مواعيد في التواريخ المحددة',
    heb: 'תורים בתאריכים שנבחרו',
    ru: 'Встречи на выбранные даты',
  },

  closedDayAppointmentsWarning: {
    en: 'You already have appointments booked on the selected dates.',
    ar: 'لديك مواعيد محجوزة في التواريخ المحددة.',
    heb: 'כבר יש לך תורים שנקבעו בתאריכים שבחרת.',
    ru: 'У вас уже есть записи на выбранные даты.',
  },

  bookedAppointments: {
    en: 'Booked appointments',
    ar: 'المواعيد المحجوزة',
    heb: 'תורים שנקבעו',
    ru: 'Забронированные встречи',
  },

  continueAnyway: {
    en: 'Continue',
    ar: 'متابعة',
    heb: 'המשך',
    ru: 'Продолжить',
  },
  newClients: {
    en: 'New Customers',
    ar: 'الزبائن الجدد',
    heb: 'לקוחות חדשים',
    ru: 'Новые клиенты',
  },
  showingNewClients: {
    en: 'Showing New',
    ar: 'عرض الجديد',
    heb: 'מציג חדשים',
    ru: 'Показаны новые',
  },
  addQuestionnaire: {
    en: 'Add Questionnaire',
    ar: 'إضافة استبيان',
    heb: 'הוספת שאלון',
    ru: 'Добавить анкету',
  },
  selectOption: {
    en: 'Select Option',
    ar: 'اختيار',
    heb: 'בחר אפשרות',
    ru: 'Выберите вариант',
  },
  confirmed: {
    en: 'Confirmed',
    ar: 'جاي',
    heb: 'מגיע',
    ru: 'Подтверждено',
  },
  noShow: {
    en: 'No Show',
    ar: 'لم يحضر',
    heb: 'לא הגיע',
    ru: 'Не явился',
  },
  search: {
    en: 'Search',
    ar: 'ابحث',
    heb: 'חיפוש',
    ru: 'Поиск',
  },
  allItemsLoaded: {
    en: 'All Customers loaded',
    ar: 'تم تحميل جميع الزبائن',
    heb: 'כל הלקוחות טעונים',
    ru: 'Все клиенты загружены',
  },
  loadMore: {
    en: 'Load More',
    ar: 'تحميل المزيد',
    heb: 'טעונה עוד',
    ru: 'Загрузить еще',
  },
  remove: {
    en: 'Remove',
    ar: 'إزالة',
    heb: 'הסרה',
    ru: 'Удалить',
  },
  weeklyHoursMobileNote: {
    en: 'Changes made here will update your general weekly opening hours.To adjust the hours for a specific day (like holidays or one-time changes), please use the "Specific Dates" tab.',
    ar: 'التعديلات هنا ستغيّر ساعات العمل الأسبوعية العامة للمصلحة. لتعديل يوم معيّن (مثل الأعياد أو تغييرات مؤقتة)، يُرجى استخدام "استثناءات".',
    heb: 'שינוי השעות כאן יעדכן את שעות הפעילות השבועיות הקבועות של העסק. לשינויים חד-פעמיים או ימים ספציפיים (כמו חגים), לחצו על "חריגים".',
    ru: 'Изменения здесь обновят ваши общие еженедельные часы работы. Для корректировки часов в конкретный день (например, праздники или разовые изменения), используйте вкладку "Конкретные даты".',
  },

  // Appointments View translations
  todays_appointments: {
    en: "Today's Appointments",
    ar: 'مواعيد اليوم',
    heb: 'תורים להיום',
    ru: 'Записи на сегодня',
  },
  happening_now: {
    en: 'Happening now',
    ar: 'يحدث الآن',
    heb: 'מתרחש עכשיו',
    ru: 'Происходит сейчас',
  },
  minutes_until: {
    en: 'min until',
    ar: 'دقيقة حتى',
    heb: 'דקות עד',
    ru: 'мин до',
  },
  hours_until: {
    en: 'hours until',
    ar: 'ساعة حتى',
    heb: 'שעות עד',
    ru: 'часов до',
  },
  no_upcoming_appointments: {
    en: 'No upcoming appointments',
    ar: 'لا توجد مواعيد قادمة',
    heb: 'אין תורים קרובים',
    ru: 'Нет предстоящих записей',
  },
  no_appointments_today: {
    en: 'No appointments scheduled for today.',
    ar: 'لا توجد مواعيد مجدولة اليوم.',
    heb: 'אין פגישות מתוכננות להיום.',
    ru: 'На сегодня встреч не запланировано.',
  },

  no_appointments_selected_date: {
    en: 'No appointments scheduled for the selected date.',
    ar: 'لا توجد مواعيد مجدولة للتاريخ المحدد.',
    heb: 'אין פגישות מתוכננות לתאריך הנבחר.',
    ru: 'На выбранную дату встреч не запланировано.',
  },

  upcoming_appointments: {
    en: 'upcoming appointments',
    ar: 'المواعيد القادمة',
    heb: 'תורים קרובים',
    ru: 'предстоящие встречи',
  },
  add_appointment: {
    en: 'Add Appointment',
    ar: 'إضافة موعد',
    heb: 'הוספת תור',
    ru: 'Добавить запись',
  },

  // Recurring appointment translations
  recurringAppointment: {
    en: 'Recurring Appointment',
    ar: 'موعد متكرر',
    heb: 'פגישה חוזרת',
    ru: 'Повторяющаяся запись',
  },
  recurringAppointments: {
    en: 'Recurring Appointments',
    ar: 'مواعيد متكررة',
    heb: 'פגישות חוזרות',
    ru: 'Повторяющиеся записи',
  },
  recurringAppointmentsDescription: {
    en: 'View and manage all recurring appointments',
    ar: 'عرض وإدارة جميع المواعيد المتكررة',
    heb: 'הצג ונהל את כל הפגישות החוזרות',
    ru: 'Просмотр и управление всеми повторяющимися записями',
  },
  noRecurringAppointments: {
    en: 'No recurring appointments found',
    ar: 'لم يتم العثور على مواعيد متكررة',
    heb: 'לא נמצאו פגישות חוזרות',
    ru: 'Повторяющиеся записи не найдены',
  },

  // Punch cards (כרטיסיות)
  punchCards: {
    en: 'Punch Cards',
    ar: 'بطاقات الخصم',
    heb: 'כרטיסיות',
    ru: 'Абонементы',
  },
  punchCardsDescription: {
    en: 'View and manage customer punch cards',
    ar: 'عرض وإدارة بطاقات الخصم للزبائن',
    heb: 'הצג ונהל כרטיסיות לקוחות',
    ru: 'Просмотр и управление абонементами клиентов',
  },
  noPunchCards: {
    en: 'No punch cards found',
    ar: 'لم يتم العثور على بطاقات',
    heb: 'לא נמצאו כרטיסיות',
    ru: 'Абонементы не найдены',
  },
  addPunchCard: {
    en: 'Add punch card',
    ar: 'إضافة بطاقة',
    heb: 'הוסף כרטיסייה',
    ru: 'Добавить абонемент',
  },
  cardQuantity: {
    en: 'Number of visits',
    ar: 'عدد الزيارات',
    heb: 'מספר ביקורים',
    ru: 'Количество посещений',
  },
  cardQuantityRequired: {
    en: 'Number of visits is required',
    ar: 'عدد الزيارات مطلوب',
    heb: 'מספר הביקורים הוא שדה חובה',
    ru: 'Укажите количество посещений',
  },
  quantityUsed: {
    en: 'Visits used',
    ar: 'الزيارات المستخدمة',
    heb: 'ביקורים שנוצלו',
    ru: 'Использовано посещений',
  },
  expirationDate: {
    en: 'Expiration date',
    ar: 'تاريخ الانتهاء',
    heb: 'תאריך תפוגה',
    ru: 'Срок действия',
  },
  supportsAllAppointments: {
    en: 'All service types',
    ar: 'جميع أنواع الخدمات',
    heb: 'כל סוגי השירותים',
    ru: 'Все типы услуг',
  },
  supportedAppointments: {
    en: 'Supported services',
    ar: 'الخدمات المدعومة',
    heb: 'שירותים נתמכים',
    ru: 'Поддерживаемые услуги',
  },
  allAppointments: {
    en: 'All services',
    ar: 'جميع الخدمات',
    heb: 'כל השירותים',
    ru: 'Все услуги',
  },
  usage: {
    en: 'Usage',
    ar: 'الاستخدام',
    heb: 'שימוש',
    ru: 'Использование',
  },
  created: {
    en: 'Created',
    ar: 'تم الإنشاء',
    heb: 'נוצר',
    ru: 'Создано',
  },
  savedPunchCards: {
    en: 'Saved punch cards',
    ar: 'بطاقات محفوظة',
    heb: 'כרטיסיות שמורות',
    ru: 'Сохранённые абонементы',
  },
  applyTemplate: {
    en: 'Apply template',
    ar: 'تطبيق القالب',
    heb: 'החל תבנית',
    ru: 'Применить шаблон',
  },
  punchCardUsed: {
    en: 'Punch card used',
    ar: 'تم استخدام بطاقة',
    heb: 'נעשה שימוש בכרטיסייה',
    ru: 'Использован абонемент',
  },
  selectPunchCard: {
    en: 'Punch card',
    ar: 'بطاقة',
    heb: 'כרטיסייה',
    ru: 'Абонемент',
  },
  noPunchCard: {
    en: 'None',
    ar: 'بدون',
    heb: 'ללא',
    ru: 'Нет',
  },
  noServices: {
    en: 'No services available',
    ar: 'لا توجد خدمات',
    heb: 'אין שירותים זמינים',
    ru: 'Нет доступных услуг',
  },

  weekly: {
    en: 'Weekly',
    ar: 'أسبوعياً',
    heb: 'שבועי',
    ru: 'Еженедельно',
  },
  biweekly: {
    en: 'Bi-weekly',
    ar: 'كل أسبوعين',
    heb: 'דו שבועי',
    ru: 'Раз в две недели',
  },
  monthly: {
    en: 'Monthly',
    ar: 'شهرياً',
    heb: 'חודשי',
    ru: 'Ежемесячно',
  },
  serviceType: {
    en: 'Service Type',
    ar: 'نوع الخدمة',
    heb: 'סוג שירות',
    ru: 'Тип услуги',
  },
  unknown: {
    en: 'Unknown',
    ar: 'غير معروف',
    heb: 'לא ידוע',
    ru: 'Неизвестно',
  },
  recurringSettings: {
    en: 'Recurring Settings',
    ar: 'إعدادات التكرار',
    heb: 'הגדרות חזרה',
    ru: 'Настройки повторения',
  },
  frequency: {
    en: 'Frequency',
    ar: 'التكرار',
    heb: 'תדירות',
    ru: 'Частота',
  },
  weeks: {
    en: 'weeks',
    ar: 'أسابيع',
    heb: 'שבועות',
    ru: 'недель',
  },
  week: {
    en: 'week',
    ar: 'أسبوع',
    heb: 'שבוע',
    ru: 'неделя',
  },
  every: {
    en: 'Every',
    ar: 'كل',
    heb: 'כל',
    ru: 'Каждые',
  },
  dayOfWeek: {
    en: 'Day of Week',
    ar: 'يوم الأسبوع',
    heb: 'יום בשבוע',
    ru: 'День недели',
  },
  time: {
    en: 'Time',
    ar: 'الوقت',
    heb: 'זמן',
    ru: 'Время',
  },
  startDate: {
    en: 'Start Date',
    ar: 'تاريخ البداية',
    heb: 'תאריך התחלה',
    ru: 'Дата начала',
  },
  setEndDate: {
    en: 'Set End Date (Optional)',
    ar: 'تعيين تاريخ الانتهاء (اختياري)',
    heb: 'קבע תאריך סיום (אופציונלי)',
    ru: 'Установить дату окончания (необязательно)',
  },
  endDateExplanation: {
    en: 'The date after which no more recurring events will be created (doesn\'t have to be the date of the last appointment)',
    ar: 'التاريخ الذي لن يتم بعده إنشاء أحداث متكررة جديدة (ليس بالضرورة أن يكون تاريخ الموعد الأخير)',
    heb: 'התאריך שאחריו לא ייווצרו עוד אירועים חוזרים (לא חייב להיות תאריך הפגישה האחרונה)',
    ru: 'Дата, после которой не будут создаваться новые повторяющиеся события (необязательно должна совпадать с датой последней встречи)',
  },
  scheduleRecurring: {
    en: 'Schedule Recurring',
    ar: 'جدولة متكررة',
    heb: 'קבע פגישה חוזרת',
    ru: 'Запланировать повторение',
  },
  recurringEvent: {
    en: 'Recurring Event',
    ar: 'حدث متكرر',
    heb: 'אירוע חוזר',
    ru: 'Повторяющееся событие',
  },
  cancelSeries: {
    en: 'Cancel Series',
    ar: 'إلغاء السلسلة',
    heb: 'בטל סדרה',
    ru: 'Отменить серию',
  },
  cancelRecurringSeries: {
    en: 'Cancel Recurring Series',
    ar: 'إلغاء سلسلة المواعيد المتكررة',
    heb: 'ביטול סדרת פגישות חוזרות',
    ru: 'Отменить повторяющуюся серию',
  },
  confirmCancelRecurringSeries: {
    en: 'Are you sure you want to cancel this entire recurring series? This will cancel all future appointments in this series.',
    ar: 'هل أنت متأكد من إلغاء سلسلة المواعيد المتكررة بالكامل؟ سيؤدي هذا إلى إلغاء جميع المواعيد المستقبلية في هذه السلسلة.',
    heb: 'האם אתה בטוח שברצונך לבטל את כל סדרת הפגישות החוזרות? פעולה זו תבטל את כל הפגישות העתידיות בסדרה זו.',
    ru: 'Вы уверены, что хотите отменить всю повторяющуюся серию? Это отменит все будущие встречи в этой серии.',
  },
  sunday: {
    en: 'Sunday',
    ar: 'الأحد',
    heb: 'יום ראשון',
    ru: 'Воскресенье',
  },
  monday: {
    en: 'Monday',
    ar: 'الإثنين',
    heb: 'יום שני',
    ru: 'Понедельник',
  },
  tuesday: {
    en: 'Tuesday',
    ar: 'الثلاثاء',
    heb: 'יום שלישי',
    ru: 'Вторник',
  },
  wednesday: {
    en: 'Wednesday',
    ar: 'الأربعاء',
    heb: 'יום רביעי',
    ru: 'Среда',
  },
  thursday: {
    en: 'Thursday',
    ar: 'الخميس',
    heb: 'יום חמישי',
    ru: 'Четверг',
  },
  friday: {
    en: 'Friday',
    ar: 'الجمعة',
    heb: 'יום שישי',
    ru: 'Пятница',
  },
  saturday: {
    en: 'Saturday',
    ar: 'السبت',
    heb: 'יום שבת',
    ru: 'Суббота',
  },
  day: {
    en: 'Day',
    ar: 'يوم',
    heb: 'יום',
    ru: 'День',
  },
  days: {
    en: 'days',
    ar: 'أيام',
    heb: 'ימים',
    ru: 'дней',
  },
  month: {
    en: 'Month',
    ar: 'شهر',
    heb: 'חודש',
    ru: 'Месяц',
  },
  year: {
    en: 'Year',
    ar: 'سنة',
    heb: 'שנה',
    ru: 'Год',
  },

  // Error boundary translations
  errorOccurred: {
    en: 'An error has occurred',
    ar: 'حدث خطأ',
    heb: 'אירעה שגיאה',
    ru: 'Произошла ошибка',
  },
  errorMessage: {
    en: 'No worries, we received the error and will fix it as soon as possible',
    ar: 'لا تقلق، لقد تلقينا الخطأ وسنقوم بإصلاحه في أقرب وقت ممكن',
    heb: 'אל תדאג, קיבלנו את השגיאה ונתקן אותה בהקדם האפשרי',
    ru: 'Не волнуйтесь, мы получили ошибку и исправим её как можно скорее',
  },
  clickToGoHome: {
    en: 'Click here to go back home',
    ar: 'انقر هنا للعودة إلى الصفحة الرئيسية',
    heb: 'לחץ כאן כדי לחזור הביתה',
    ru: 'Нажмите здесь, чтобы вернуться домой',
  },
  backToHome: {
    en: 'Back to Home',
    ar: 'العودة إلى الصفحة الرئيسية',
    heb: 'חזרה הביתה',
    ru: 'Назад домой',
  },

  // Message Dialog translations
  sendMessage: {
    en: 'Send Message',
    ar: 'إرسال رسالة',
    heb: 'שלח הודעה',
    ru: 'Отправить сообщение',
  },
  message: {
    en: 'Message',
    ar: 'رسالة',
    heb: 'הודעה',
    ru: 'Сообщение',
  },
  typeYourMessage: {
    en: 'Type your message here...',
    ar: 'اكتب رسالتك هنا...',
    heb: 'הקלד את ההודעה שלך כאן...',
    ru: 'Введите ваше сообщение здесь...',
  },
  send: {
    en: 'Send',
    ar: 'إرسال',
    heb: 'שלח',
    ru: 'Отправить',
  },

  // Template management
  saveTemplate: {
    en: 'Save Template',
    ar: 'حفظ القالب',
    heb: 'שמור תבנית',
    ru: 'Сохранить шаблон',
  },
  templateName: {
    en: 'Template Name',
    ar: 'اسم القالب',
    heb: 'שם התבנית',
    ru: 'Название шаблона',
  },
  enterTemplateName: {
    en: 'Enter template name',
    ar: 'أدخل اسم القالب',
    heb: 'הזן שם תבנית',
    ru: 'Введите название шаблона',
  },
  templates: {
    en: 'Templates',
    ar: 'قوالب',
    heb: 'תבניות',
    ru: 'Шаблоны',
  },
  selectTemplate: {
    en: 'Select a template',
    ar: 'اختر قالبًا',
    heb: 'בחר תבנית',
    ru: 'Выберите шаблон',
  },
  recipient: {
    en: 'Recipient',
    ar: 'المستلم',
    heb: 'נמען',
    ru: 'Получатель',
  },
  recipients: {
    en: 'Recipients',
    ar: 'المستلمين',
    heb: 'נמענים',
    ru: 'Получатели',
  },
  customersSelected: {
    en: 'customers selected',
    ar: 'زبائن محددين',
    heb: 'לקוחות נבחרו',
    ru: 'выбрано клиентов',
  },
  clearSelection: {
    en: 'Clear selection',
    ar: 'مسح التحديد',
    heb: 'נקה בחירה',
    ru: 'Очистить выбор',
  },
  andXMore: {
    en: 'and {0} more...',
    ar: 'و {0} أكثر...',
    heb: 'ועוד {0}...',
    ru: 'и еще {0}...',
  },
  cancelSendMessage: {
    en: 'Cancel Selection',
    ar: 'إلغاء التحديد',
    heb: 'ביטול הבחירה',
    ru: 'Отменить выбор',
  },
  manageTemplates: {
    en: 'Manage Templates',
    ar: 'إدارة القوالب',
    heb: 'נהל תבניות',
    ru: 'Управление шаблонами',
  },
  noTemplates: {
    en: 'No templates found',
    ar: 'لم يتم العثور على قوالب',
    heb: 'לא נמצאו תבניות',
    ru: 'Шаблоны не найдены',
  },
  done: {
    en: 'Done',
    ar: 'تم',
    heb: 'סיום',
    ru: 'Готово',
  },
  editTemplate: {
    en: 'Edit Template',
    ar: 'تعديل القالب',
    heb: 'עריכת תבנית',
    ru: 'Редактировать шаблон',
  },
  updateTemplate: {
    en: 'Update Template',
    ar: 'تحديث القالب',
    heb: 'עדכן תבנית',
    ru: 'Обновить шаблон',
  },
  advancedScheduling: {
    en: 'Other Time',
    ar: 'وقت ثاني',
    heb: 'זמן אחר',
    ru: 'Другое время',
  },
  customTime: {
    en: "Use when the client wants a time that isn't listed in the schedule",
    ar: 'استعملها إذا الزبون بدّه وقت مش موجود بالقائمة',
    heb: 'השתמש כשלקוח מבקש זמן שלא מופיע ברשימת הזמנים',
    ru: 'Используйте, если клиент хочет время, которого нет в расписании',
  },
  invalidTime: {
    en: 'Invalid Time',
    ar: 'وقت غير صالح',
    heb: 'זמן שגוי',
    ru: 'Неверное время',
  },
  additionalCost: {
    en: 'Additional Cost',
    ar: 'تكلفة إضافية',
    heb: 'עלות נוספת',
    ru: 'Дополнительная стоимость',
  },
  cannotSchedulePastTime: {
    en: 'You cannot schedule an appointment in the past. Please select a future time',
    ar: 'لا يمكنك جدولة موعد في الماضي. يرجى اختيار وقت في المستقبل',
    heb: 'אין לקבוע פגישה בעבר. נא לבחור זמן בעתיד',
    ru: 'Вы не можете запланировать встречу в прошлом. Пожалуйста, выберите будущее время',
  },
  breakEndTimeBeforeStart: {
    en: 'End time must be after start time. Please adjust the break times.',
    ar: 'يجب أن يكون وقت الانتهاء بعد وقت البدء. يرجى تعديل أوقات الاستراحة.',
    heb: 'שעת הסיום חייבת להיות אחרי שעת ההתחלה. נא לעדכן את שעות ההפסקה.',
    ru: 'Время окончания должно быть позже времени начала. Пожалуйста, измените время перерыва.',
  },
  dailyUsed: {
    en: 'Daily used',
    ar: 'الرسائل المستخدمة اليوم',
    heb: 'נשלחו היום',
    ru: 'Использовано за день',
  },
  monthlyUsed: {
    en: 'Monthly used',
    ar: 'الرسائل المستخدمة هذا الشهر',
    heb: 'נשלחו החודש',
    ru: 'Использовано за месяц',
  },
  dailyLimitExceeded: {
    en: 'Daily messaging limit exceeded',
    ar: 'تم تجاوز الحد اليومي للرسائل',
    heb: 'חרגת ממכסת ההודעות היומית',
    ru: 'Превышен дневной лимит сообщений',
  },
  monthlyLimitExceeded: {
    en: 'Monthly messaging limit exceeded',
    ar: 'تم تجاوز الحد الشهري للرسائل',
    heb: 'חרגת ממכסת ההודעות החודשית',
    ru: 'Превышен месячный лимит сообщений',
  },
  bulkLimitWarning: {
    en: 'You can only send to',
    ar: 'يمكنك فقط الإرسال إلى',
    heb: 'אתה יכול לשלוח רק ל',
    ru: 'Вы можете отправить только',
  },
  recipientsNow: {
    en: 'recipients now',
    ar: 'مستلمين الآن',
    heb: 'נמענים כעת',
    ru: 'получателей сейчас',
  },
  insertVariables: {
    en: 'Insert Variables',
    ar: 'إدراج متغيرات',
    heb: 'הכנס משתנים',
    ru: 'Вставить переменные',
  },
  customerInfo: {
    en: 'Customer Info',
    ar: 'معلومات العميل',
    heb: 'פרטי לקוח',
    ru: 'Информация о клиенте',
  },
  customerName: {
    en: 'Customer Name',
    ar: 'اسم الزبون',
    heb: 'שם הלקוח',
    ru: 'Имя клиента',
  },
  customerPhone: {
    en: 'Customer Phone',
    ar: 'هاتف الزبون',
    heb: 'טלפון לקוח',
    ru: 'Телефон клиента',
  },
  genericDetails: {
    en: 'Custom Fields',
    ar: 'حقول مخصصة',
    heb: 'שדות מותאמים אישית',
    ru: 'Пользовательские поля',
  },
  currentVariables: {
    en: 'Current Variables',
    ar: 'المتغيرات الحالية',
    heb: 'משתנים נוכחיים',
    ru: 'Текущие переменные',
  },
  removeVariable: {
    en: 'Remove Variable',
    ar: 'إزالة المتغير',
    heb: 'הסר משתנה',
    ru: 'Удалить переменную',
  },
  resetTemplate: {
    en: 'Reset Template',
    ar: 'إعادة تعيين القالب',
    heb: 'אפס תבנית',
    ru: 'Сбросить шаблон',
  },
  // Questionnaire messaging translations
  selectQuestionnaire: {
    en: 'Select Questionnaire (Optional)',
    ar: 'اختر استبيان (اختياري)',
    heb: 'בחר שאלון (אופציונלי)',
    ru: 'Выберите анкету (необязательно)',
  },
  noQuestionnaire: {
    en: 'No Questionnaire',
    ar: 'بدون استبيان',
    heb: 'ללא שאלון',
    ru: 'Без анкеты',
  },
  questionnaireSelected: {
    en: 'This will prompt the customer to fill out a questionnaire',
    ar: 'ستطلب من العميل ملء استبيان',
    heb: 'הודעה זו תצפה לקוח למלא שאלון',
    ru: 'Это сообщение попросит клиента заполнить анкету',
  },
  withQuestionnaire: {
    en: 'With Questionnaire',
    ar: 'مع استبيان',
    heb: 'עם שאלון',
    ru: 'С анкетой',
  },

  // Date picker translations
  singleDate: {
    en: 'Single Date',
    ar: 'تاريخ واحد',
    heb: 'תאריך יחיד',
    ru: 'Одна дата',
  },

  dateRange: {
    en: 'Date Range',
    ar: 'نطاق التواريخ',
    heb: 'טווח תאריכים',
    ru: 'Диапазон дат',
  },

  selectMode: {
    en: 'Selection Mode',
    ar: 'وضع الاختيار',
    heb: 'מצב בחירה',
    ru: 'Режим выбора',
  },

  open: {
    en: 'Open',
    ar: 'مفتوح',
    heb: 'פתוח',
    ru: 'Открыто',
  },

  closed: {
    en: 'Closed',
    ar: 'مغلق',
    heb: 'סגור',
    ru: 'Закрыто',
  },

  start: {
    en: 'Start',
    ar: 'البداية',
    heb: 'התחלה',
    ru: 'Начало',
  },

  end: {
    en: 'End',
    ar: 'النهاية',
    heb: 'סיום',
    ru: 'Конец',
  },

  addShift: {
    en: 'Add Shift',
    ar: 'إضافة وردية',
    heb: 'הוסף משמרת',
    ru: 'Добавить смену',
  },

  update: {
    en: 'Update',
    ar: 'تحديث',
    heb: 'עדכן',
    ru: 'Обновить',
  },

  selectDates: {
    en: 'Selected Dates',
    ar: 'تاريخ محدد',
    heb: 'תאריכים נבחרו',
    ru: 'Выбранные даты',
  },

  addDateSpecificHours: {
    en: 'Add Date-Specific Hours',
    ar: 'إضافة ساعات خاصة بالتاريخ',
    heb: 'הוסף שעות ספציפיות לתאריך',
    ru: 'Добавить часы для конкретной даты',
  },

  workingHours: {
    en: 'Working Hours',
    ar: 'ساعات العمل',
    heb: 'שעות עבודה',
    ru: 'Рабочие часы',
  },

  applyToAllDates: {
    en: 'Apply to all selected dates',
    ar: 'تطبيق على جميع التواريخ المحددة',
    heb: 'החל על כל התאריכים הנבחרים',
    ru: 'Применить ко всем выбранным датам',
  },

  customHours: {
    en: 'Custom Hours',
    ar: 'ساعات مخصصة',
    heb: 'שעות מותאמות אישית',
    ru: 'Пользовательские часы',
  },

  selectDateFirst: {
    en: 'Please select a date first',
    ar: 'يرجى اختيار تاريخ أولاً',
    heb: 'אנא בחר תאריך קודם',
    ru: 'Пожалуйста, сначала выберите дату',
  },

  chooseDateRange: {
    en: 'Choose date range',
    ar: 'اختر نطاق التاريخ',
    heb: 'בחר טווח תאריכים',
    ru: 'Выберите диапазон дат',
  },

  chooseDate: {
    en: 'Choose date',
    ar: 'اختر التاريخ',
    heb: 'בחר תאריך',
    ru: 'Выберите дату',
  },

  showOnlyInDashboard: {
    en: 'Allow customers to schedule this service',
    ar: 'السماح للزبائن حجز هذه الخدمة',
    heb: 'לאפשר ללקוחות להזמין את השירות הזה',
    ru: 'Позволить клиентам забронировать эту услугу',
  },

  bulkCancelRefundNote: {
    en: 'Note: Bulk cancellation will automatically refund all canceled appointments, regardless of your refund policy settings.',
    ar: 'ملاحظة: الإلغاء الجماعي سيؤدي تلقائياً إلى استرداد عرابين جميع المواعيد الملغاة، بغض النظر عن إعدادات سياسة الاسترداد.',
    heb: 'הערה: ביטול המוני יחזיר אוטומטית את כל התשלומים עבור התורים המבוטלים, ללא קשר להגדרות מדיניות ההחזר שלך.',
    ru: 'Примечание: Массовая отмена автоматически вернёт деньги за все отменённые встречи, независимо от настроек политики возврата.',
  },
  appointments: {
    en: 'Appointments',
    ar: 'مواعيد',
    heb: 'תורים',
    ru: 'Встречи',
  },
  noAppointments: {
    en: 'No appointments found',
    ar: 'لا يوجد مواعيد',
    heb: 'אין תורים',
    ru: 'Встречи не найдены',
  },
  language: {
    en: 'Language',
    ar: 'اللغة',
    heb: 'שפה',
    ru: 'Язык',
  },
  
  // Appointment booking error
  bookingError: {
    en: 'Booking Failed',
    ar: 'فشل الحجز',
    heb: 'ההזמנה נכשלה',
    ru: 'Ошибка бронирования',
  },
  bookingErrorDescription: {
    en: 'Something went wrong while booking the appointment. Please try again.',
    ar: 'حدث خطأ أثناء حجز الموعد. يرجى المحاولة مرة أخرى.',
    heb: 'משהו השתבש בזמן ההזמנה. אנא נסה שוב.',
    ru: 'Что-то пошло не так при бронировании. Пожалуйста, попробуйте снова.',
  },
  slotLockedErrorDescription: {
    en: 'A client is scheduling this time slot. Please choose another time or wait a few minutes and try again.',
    ar: 'يوجد زبون بحاول يحجز موعد لهذا الوقت. يرجى اختيار وقت آخر أو انتظار بضع دقائق ومحاولة مرة أخرى',
    heb: 'לקוח מנסה לשריין את השעה הזו. אנא בחרו שעה אחרת או חכו קצת ונסו שוב.',
    ru: 'Клиент забронировал это время. Пожалуйста, выберите другое время или подождите несколько минут и попробуйте снова.',
  },
  ok: {
    en: 'OK',
    ar: 'حسناً',
    heb: 'אישור',
    ru: 'ОК',
  },

  // Tier subscription tracking (Rami Molla)
  didntStart: {
    en: "didn't start",
    ar: 'لم يبدأ',
    heb: 'לא התחיל',
    ru: 'не начался',
  },
  remainsXMonths: {
    en: 'remains {0} months',
    ar: 'متبقي {0} أشهر',
    heb: 'נותרו {0} חודשים',
    ru: 'осталось {0} месяцев',
  },
  remains1Month: {
    en: 'remains 1 month',
    ar: 'متبقي شهر واحد',
    heb: 'נותר חודש אחד',
    ru: 'остался 1 месяц',
  },
  expired: {
    en: 'expired',
    ar: 'انتهت',
    heb: 'פג תוקף',
    ru: 'истёк',
  },
  finishedThisMonth: {
    en: 'finished this month',
    ar: 'انتهى هذا الشهر',
    heb: 'הסתיים החודש',
    ru: 'закончился в этом месяце',
  },
  finished1MonthAgo: {
    en: 'finished 1 month ago',
    ar: 'انتهى منذ شهر',
    heb: 'הסתיים לפני חודש',
    ru: 'закончился 1 месяц назад',
  },
  finishedXMonthsAgo: {
    en: 'finished {0} months ago',
    ar: 'انتهى منذ {0} أشهر',
    heb: 'הסתיים לפני {0} חודשים',
    ru: 'закончился {0} месяцев назад',
  },
  finishedFilter: {
    en: 'Finished',
    ar: 'انتهى',
    heb: 'הסתיים',
    ru: 'Завершено',
  },
  tierEndMonth: {
    en: 'End Month',
    ar: 'شهر الانتهاء',
    heb: 'חודש סיום',
    ru: 'Месяц окончания',
  },
  tierProgress: {
    en: 'Progress',
    ar: 'التقدم',
    heb: 'התקדמות',
    ru: 'Прогресс',
  },

  // Group-based recurring appointments
  selectGroup: {
    en: 'Select Group',
    ar: 'اختر المجموعة',
    heb: 'בחר קבוצה',
    ru: 'Выбрать группу',
  },
  recurringRules: {
    en: 'Recurring Rules',
    ar: 'قواعد التكرار',
    heb: 'כללי חזרה',
    ru: 'Правила повторения',
  },

  // Groups tab translations
  groups: {
    en: 'Groups',
    ar: 'المجموعات',
    heb: 'קבוצות',
    ru: 'Группы',
  },
  groupMembership: {
    en: 'Group Membership',
    ar: 'عضوية المجموعة',
    heb: 'חברות בקבוצה',
    ru: 'Членство в группе',
  },
  currentRecurringAppointments: {
    en: 'Current Recurring Appointments',
    ar: 'المواعيد المتكررة الحالية',
    heb: 'פגישות חוזרות נוכחיות',
    ru: 'Текущие повторяющиеся встречи',
  },
  availableSlots: {
    en: 'Available Slots',
    ar: 'الأوقات المتاحة',
    heb: 'משבצות זמינות',
    ru: 'Доступные слоты',
  },
  noGroupsConfigured: {
    en: 'No groups configured',
    ar: 'لم يتم تكوين مجموعات',
    heb: 'לא הוגדרו קבוצות',
    ru: 'Группы не настроены',
  },
  add: {
    en: 'Add',
    ar: 'إضافة',
    heb: 'הוסף',
    ru: 'Добавить',
  },

  // Multi-day break event translations
  multiDayBreakInfo: {
    en: 'Part of multi-day break',
    ar: 'جزء من استراحة متعددة الأيام',
    heb: 'חלק מהפסקה רב-יומית',
    ru: 'Часть многодневного перерыва',
  },
  multiDayBreakWarning: {
    en: 'This is a multi-day break spanning',
    ar: 'هذه استراحة متعددة الأيام تمتد',
    heb: 'זוהי הפסקה רב-יומית הנמשכת',
    ru: 'Это многодневный перерыв продолжительностью',
  },
  areYouSureDelete: {
    en: 'Are you sure you want to delete it?',
    ar: 'هل أنت متأكد أنك تريد حذفه؟',
    heb: 'האם אתה בטוח שברצונך למחוק?',
    ru: 'Вы уверены, что хотите удалить?',
  },
  areYouSureArchivePunchCard: {
    en: 'Are you sure you want to archive this punch card?',
    ar: 'هل أنت متأكد أنك تريد أرشفة بطاقة النقاط هذه؟',
    heb: 'האם אתה בטוח שברצונך לארכב את כרטיסיית הניקוב?',
    ru: 'Вы уверены, что хотите архивировать эту карту?',
  },
  areYouSureUnarchivePunchCard: {
    en: 'Are you sure you want to restore this punch card?',
    ar: 'هل أنت متأكد أنك تريد استعادة بطاقة النقاط هذه؟',
    heb: 'האם אתה בטוח שברצונך להוציא מארכיון את כרטיסיית הניקוב?',
    ru: 'Вы уверены, что хотите восстановить эту карту?',
  },

  // Chunk loading error
  loadingNewVersion: {
    en: 'Loading new version...',
    ar: 'جاري تحميل نسخة جديدة...',
    heb: 'טוען גרסה חדשה...',
    ru: 'Загрузка новой версии...',
  },

  // Staff management
  cannotHideLastStaff: {
    en: 'You must keep at least one staff member visible. This is the last visible staff member.',
    ar: 'يجب الإبقاء على عضو فريق واحد على الأقل ظاهراً. هذا هو عضو الفريق الأخير الظاهر.',
    heb: 'חובה להשאיר לפחות איש צוות אחד גלוי. זהו איש הצוות האחרון הגלוי.',
    ru: 'Необходимо сохранить хотя бы одного видимого сотрудника. Это последний видимый сотрудник.',
  },
  addStaff: {
    en: 'Add staff',
    ar: 'إضافة عضو فريق',
    heb: 'הוסף איש צוות',
    ru: 'Добавить сотрудника',
  },

  // PDF Download
  downloadPdf: {
    en: 'Download PDF',
    ar: 'تحميل PDF',
    heb: 'הורד PDF',
    ru: 'Скачать PDF',
  },

  // Restricted scheduling feature
  restrictedScheduling: {
    en: 'Scheduling Access',
    ar: 'صلاحيات الحجز',
    heb: 'הרשאות תיאום',
    ru: 'Доступ к записи',
  },
  enableAllScheduling: {
    en: 'Allow scheduling all services',
    ar: 'خلّيه يحجز كل شي',
    heb: 'אפשר קביעת כל השירותים',
    ru: 'Разрешить запись всех сервисов',
  },
  enableAllSchedulingDesc: {
    en: 'Override all restrictions for this customer',
    ar: 'بيلغي كل القيود لهذا الزبون',
    heb: 'בטל את כל ההגבלות עבור לקוח זה',
    ru: 'Отменить все ограничения для этого клиента',
  },
  noApts: {
    en: 'No services configured',
    ar: 'ما في أنواع مواعيد محددة',
    heb: 'לא הוגדרו שירותים',
    ru: 'Сервисы не настроены',
  },
  selectAllowedApts: {
    en: 'Toggle which services this customer can schedule:',
    ar: 'اختار أي مواعيد يقدر الزبون يحجز:',
    heb: 'בחר אילו שירותים הלקוח יכול לקבוע:',
    ru: 'Выберите, какие сервисы доступны этому клиенту:',
  },
  restrictedByDefault: {
    en: 'Restricted by default',
    ar: 'مقيد تلقائياً',
    heb: 'מוגבל כברירת מחדל',
    ru: 'Ограничено по умолчанию',
  },
  saving: {
    en: 'Saving…',
    ar: 'جاري الحفظ…',
    heb: 'שומר…',
    ru: 'Сохранение…',
  },
  saveAndSendMessage: {
    en: 'Save',
    ar: 'احفظ',
    heb: 'שמור',
    ru: 'Сохранить',
  },
  scheduling: {
    en: 'Scheduling',
    ar: 'الحجز',
    heb: 'תיאום',
    ru: 'Запись',
  },
  schedulingAllowed: {
    en: 'Can schedule any service',
    ar: 'بيقدر يحجز كل شي',
    heb: 'יכול לקבוע כל שירות',
    ru: 'Может записаться на всё',
  },
  schedulingPartial: {
    en: 'Partially restricted',
    ar: 'مقيد جزئياً ببعض الخدمات',
    heb: 'קביעת תורים מוגבלת חלקית',
    ru: 'Частично ограничено',
  },
  schedulingRestricted: {
    en: 'Scheduling restricted',
    ar: 'مش مسموح يحجز',
    heb: 'קביעת תורים מוגבלת',
    ru: 'Запись ограничена',
  },
  bookingInviteApts: {
    en: 'Customer will be able to schedule:',
    ar: 'الزبون رح يقدر يحجز:',
    heb: 'הלקוח יוכל לקבוע:',
    ru: 'Клиент сможет записаться на:',
  },

  hoursUpdatedSuccess: {
    en: 'Working hours updated',
    ar: 'تم تحديث ساعات العمل',
    heb: 'שעות העבודה עודכנו',
    ru: 'Рабочие часы обновлены',
  },

  appointmentAddedSuccess: {
    en: 'Appointment booked',
    ar: 'تم إضافة الموعد',
    heb: 'התור התווסף',
    ru: 'Запись добавлена',
  },

  appointmentCanceledSuccess: {
    en: 'Appointment canceled',
    ar: 'تم إلغاء الموعد',
    heb: 'התור בוטל',
    ru: 'Запись отменена',
  },

  appointmentRescheduledSuccess: {
    en: 'Appointment rescheduled',
    ar: 'تم إعادة جدولة الموعد',
    heb: 'התור נקבע מחדש',
    ru: 'Запись перенесена',
  },

  importantNote: {
    en: 'Important',
    ar: 'مهم',
    heb: 'חשוב',
    ru: 'Важно',
  },

  importantNoteTooltip: {
    en: 'Important notes are added to appointment notes so you won\'t forget',
    ar: 'الملاحظات المهمة تُضاف إلى ملاحظات المواعيد حتى لا تنسى',
    heb: 'הערות חשובות מתווספות להערות התור כדי שלא תשכח',
    ru: 'Важные заметки добавляются к заметкам о записи, чтобы вы не забыли',
  },

  addToCustomerProfile: {
    en: 'Add to customer profile',
    ar: 'إضافة إلى ملف العميل',
    heb: 'הוספה לפרופיל הלקוח',
    ru: 'Добавить в профиль клиента',
  },

  regPageTitle: {
    en: 'Register your business',
    ar: 'تسجيل مصلحتك',
    heb: 'הרשמת העסק',
    ru: 'Регистрация бизнеса',
  },
  regBrandEyebrow: {
    en: 'Join WATS VA',
    ar: 'انضم إلى WATS VA',
    heb: 'הצטרפו ל-WATS VA',
    ru: 'Присоединяйтесь к WATS VA',
  },
  regBrandTitle: {
    en: 'Grow your business with smarter bookings',
    ar: 'نمِّ مصلحتك بحجوزات أذكى',
    heb: 'צמחו עם ניהול תורים חכם יותר',
    ru: 'Развивайте бизнес с умными записями',
  },
  regBrandSubtitle: {
    en: 'Set up your profile in a few minutes and start accepting appointments from customers.',
    ar: 'جهّز صفحتك وابدأ باستقبال الحجوزات من الزبائن القريبين منك.',
    heb: 'הקימו פרופיל בדקות והתחילו לקבל תורים מלקוחות.',
    ru: 'Создайте профиль за несколько минут и принимайте записи от клиентов.',
  },
  regBrandPerk1: {
    en: 'Online booking, 24/7',
    ar: 'حجز أونلاين على مدار الساعة',
    heb: 'קביעת תורים אונליין, 24/7',
    ru: 'Онлайн-запись 24/7',
  },
  regBrandPerk2: {
    en: 'Get discovered on the map',
    ar: 'اظهر على الخريطة لزبائن جدد',
    heb: 'הופיעו על המפה ללקוחות חדשים',
    ru: 'Будьте видны на карте',
  },
  regBrandPerk3: {
    en: 'Manage everything from your phone',
    ar: 'أدر كل شيء من هاتفك',
    heb: 'נהלו הכל מהטלפון',
    ru: 'Управляйте всем с телефона',
  },
  regStepOf: {
    en: 'Step {current} of {total}',
    ar: 'خطوة {current} من {total}',
    heb: 'שלב {current} מתוך {total}',
    ru: 'Шаг {current} из {total}',
  },
  regStepBusiness: {
    en: 'Business',
    ar: 'المصلحة',
    heb: 'עסק',
    ru: 'Бизнес',
  },
  regStepLocation: {
    en: 'Location',
    ar: 'الموقع',
    heb: 'מיקום',
    ru: 'Адрес',
  },
  regStepPhotos: {
    en: 'Photos',
    ar: 'صور',
    heb: 'תמונות',
    ru: 'Фото',
  },
  regStepOwner: {
    en: 'Business Owner',
    ar: 'صاحب المصلحة',
    heb: 'בעלים',
    ru: 'Владелец',
  },
  regSaving: {
    en: 'Saving…',
    ar: 'جاري الحفظ…',
    heb: 'שומר…',
    ru: 'Сохранение…',
  },
  regSaved: {
    en: 'Progress saved',
    ar: 'تم حفظ التقدم',
    heb: 'ההתקדמות נשמרה',
    ru: 'Прогресс сохранён',
  },
  regBusinessHeading: {
    en: 'Tell us about your business',
    ar: 'أخبرنا عن مصلحتك',
    heb: 'ספרו לנו על העסק',
    ru: 'Расскажите о бизнесе',
  },
  regBusinessSub: {
    en: 'This is what customers will see on your public page.',
    ar: 'هذا ما سيراه الزبائن في صفحتك.',
    heb: 'זה מה שהלקוחות יראו בעמוד הציבורי.',
    ru: 'Это увидят клиенты на вашей публичной странице.',
  },
  regBusinessName: {
    en: 'Business name',
    ar: 'اسم مصلحتك',
    heb: 'שם העסק',
    ru: 'Название',
  },
  regBusinessNamePlaceholder: {
    en: 'e.g. Studio Bloom',
    ar: 'مثال: ستوديو بلوم',
    heb: 'לדוגמה: Studio Bloom',
    ru: 'Например, Studio Bloom',
  },
  regBusinessType: {
    en: 'Business type',
    ar: 'نوع مصلحتك',
    heb: 'סוג העסק',
    ru: 'Тип бизнеса',
  },
  regBusinessTypeOtherPlaceholder: {
    en: 'Tell us what kind of business it is',
    ar: 'أخبرنا ما نوع مصلحتك',
    heb: 'ספרו לנו איזה סוג עסק זה',
    ru: 'Опишите тип бизнеса',
  },
  regDescription: {
    en: 'Business description',
    ar: 'وصف مصلحتك',
    heb: 'תיאור העסק',
    ru: 'Описание',
  },
  regDescriptionPlaceholder: {
    en: 'Tell people about your business in 1-3 sentences',
    ar: 'أخبر الناس عن مصلحتك في جملة إلى ثلاث جمل',
    heb: 'ספרו לאנשים על העסק במשפט עד שלושה',
    ru: 'Расскажите о бизнесе в 1–3 предложениях',
  },
  regLocationHeading: {
    en: 'Where is your business?',
    ar: 'أين يقع مصلحتك؟',
    heb: 'איפה נמצא העסק?',
    ru: 'Где находится бизнес?',
  },
  regLocationSub: {
    en: 'Search for an address, then drag the map so the pin sits on the exact spot.',
    ar: 'ابحث عن العنوان، ثم حرّك الخريطة حتى يثبت الدبوس على الموقع الدقيق.',
    heb: 'חפשו כתובת והזיזו את המפה כך שהסיכה תשב בדיוק על המיקום.',
    ru: 'Найдите адрес и сдвиньте карту, чтобы булавка оказалась в нужной точке.',
  },
  regSearchAddress: {
    en: 'Search for an address',
    ar: 'ابحث عن عنوان',
    heb: 'חיפוש כתובת',
    ru: 'Поиск адреса',
  },
  regUseMyLocation: {
    en: 'Use my location',
    ar: 'استخدم موقعي',
    heb: 'השתמשו במיקום שלי',
    ru: 'Моё местоположение',
  },
  regUpdatingAddress: {
    en: 'Updating address…',
    ar: 'جاري تحديث العنوان…',
    heb: 'מעדכן כתובת…',
    ru: 'Обновление адреса…',
  },
  regMapHint: {
    en: 'Pan the map to place the pin. We’ll save both the address and GPS coordinates.',
    ar: 'حرّك الخريطة لوضع الدبوس. سنحفظ العنوان وإحداثيات الموقع.',
    heb: 'הזיזו את המפה כדי למקם את הסיכה. נשמור גם כתובת וגם נקודת GPS.',
    ru: 'Перемещайте карту, чтобы поставить булавку. Мы сохраним адрес и координаты.',
  },
  regPhotosHeading: {
    en: 'Show off your business',
    ar: 'اعرض مصلحتك',
    heb: 'הציגו את העסק',
    ru: 'Покажите бизнес',
  },
  regPhotosSub: {
    en: 'Add a logo and extra photos of your space or services.',
    ar: 'أضف شعارًا وصورًا إضافية للمكان أو الخدمات.',
    heb: 'הוסיפו לוגו ותמונות נוספות של המקום או השירותים.',
    ru: 'Добавьте логотип и фото пространства или услуг.',
  },
  regLogo: {
    en: 'Logo',
    ar: 'صورة بروفيل/لوجو',
    heb: 'פרופיל/לוגו',
    ru: 'Логотип',
  },
  regLogoHint: {
    en: 'Tap to upload a square logo',
    ar: 'اضغط لرفع شعار مربع',
    heb: 'הקישו להעלאת לוגו מרובע',
    ru: 'Нажмите, чтобы загрузить квадратный логотип',
  },
  regGallery: {
    en: 'Extra photos',
    ar: 'صور إضافية',
    heb: 'תמונות נוספות',
    ru: 'Дополнительные фото',
  },
  regAddPhotos: {
    en: 'Add',
    ar: 'إضافة',
    heb: 'הוספה',
    ru: 'Добавить',
  },
  regOwnerHeading: {
    en: 'Owner details',
    ar: 'بيانات المالك',
    heb: 'פרטי הבעלים',
    ru: 'Данные владельца',
  },
  regOwnerSub: {
    en: 'We’ll use this to get in touch about your account.',
    ar: 'سنستخدم هذه البيانات للتواصل بخصوص حسابك.',
    heb: 'נשתמש בפרטים האלה כדי ליצור קשר לגבי החשבון.',
    ru: 'Мы свяжемся по этим данным по поводу аккаунта.',
  },
  regOwnerFirstName: {
    en: 'First name',
    ar: 'الاسم الأول',
    heb: 'שם פרטי',
    ru: 'Имя',
  },
  regOwnerLastName: {
    en: 'Last name',
    ar: 'اسم العائلة',
    heb: 'שם משפחה',
    ru: 'Фамилия',
  },
  regOwnerPhone: {
    en: 'Phone number',
    ar: 'رقم الهاتف',
    heb: 'מספר טלפון',
    ru: 'Телефон',
  },
  regReviewTitle: {
    en: 'Summary',
    ar: 'ملخص',
    heb: 'סיכום',
    ru: 'Сводка',
  },
  regBack: {
    en: 'Back',
    ar: 'رجوع',
    heb: 'חזרה',
    ru: 'Назад',
  },
  regContinue: {
    en: 'Continue',
    ar: 'متابعة',
    heb: 'המשך',
    ru: 'Далее',
  },
  regSubmit: {
    en: 'Submit application',
    ar: 'إرسال الطلب',
    heb: 'שליחת הבקשה',
    ru: 'Отправить заявку',
  },
  regThankYouTitle: {
    en: 'Thank you!',
    ar: 'شكرًا لك!',
    heb: 'תודה!',
    ru: 'Спасибо!',
  },
  regThankYouBody: {
    en: 'We received your business details. Our team will review them and get back to you soon.',
    ar: 'استلمنا تفاصيل مصلحتك. سيراجعها فريقنا ونتواصل معك قريبًا.',
    heb: 'קיבלנו את פרטי העסק. הצוות שלנו יבדוק אותם ויחזור אליכם בקרוב.',
    ru: 'Мы получили данные бизнеса. Команда проверит их и скоро свяжется с вами.',
  },
  regBusinessNameRequired: {
    en: 'Please enter your business name.',
    ar: 'الرجاء إدخال اسم المصلحة.',
    heb: 'נא להזין את שם העסק.',
    ru: 'Укажите название бизнеса.',
  },
  regBusinessTypeRequired: {
    en: 'Please choose a business type.',
    ar: 'الرجاء اختيار نوع المصلحة.',
    heb: 'נא לבחור סוג עסק.',
    ru: 'Выберите тип бизнеса.',
  },
  regBusinessTypeOtherRequired: {
    en: 'Please describe your business type.',
    ar: 'الرجاء وصف نوع مصلحتك.',
    heb: 'נא לתאר את סוג העסק.',
    ru: 'Опишите тип бизнеса.',
  },
  regDescriptionRequired: {
    en: 'Please write 1-3 sentences about your business.',
    ar: 'الرجاء كتابة جملة إلى ثلاث جمل عن مصلحتك.',
    heb: 'נא לכתוב משפט עד שלושה על העסק.',
    ru: 'Напишите 1–3 предложения о бизнесе.',
  },
  regLocationRequired: {
    en: 'Please set your address on the map.',
    ar: 'الرجاء تحديد العنوان على الخريطة.',
    heb: 'נא לסמן את הכתובת במפה.',
    ru: 'Укажите адрес на карте.',
  },
  regLogoRequired: {
    en: 'Please upload a logo.',
    ar: 'الرجاء رفع شعار.',
    heb: 'נא להעלות לוגו.',
    ru: 'Загрузите логотип.',
  },
  regOwnerNameRequired: {
    en: 'Please enter the owner first and last name.',
    ar: 'الرجاء إدخال الاسم الأول واسم العائلة للمالك.',
    heb: 'נא להזין שם פרטי ושם משפחה של הבעלים.',
    ru: 'Укажите имя и фамилию владельца.',
  },
  regOwnerPhoneRequired: {
    en: 'Please enter a valid phone number.',
    ar: 'الرجاء إدخال رقم هاتف صالح.',
    heb: 'נא להזין מספר טלפון תקין.',
    ru: 'Укажите корректный номер телефона.',
  },
  regFileTooLarge: {
    en: 'Each image must be 8MB or smaller.',
    ar: 'يجب ألا يتجاوز حجم كل صورة 8 ميجابايت.',
    heb: 'כל תמונה חייבת להיות עד 8MB.',
    ru: 'Каждое изображение — не больше 8 МБ.',
  },
  regUploadFailed: {
    en: 'Upload failed. Please try again.',
    ar: 'فشل الرفع. الرجاء المحاولة مرة أخرى.',
    heb: 'ההעלאה נכשלה. נסו שוב.',
    ru: 'Не удалось загрузить. Попробуйте ещё раз.',
  },
  regSubmitFailed: {
    en: 'Could not submit. Please try again.',
    ar: 'تعذر الإرسال. الرجاء المحاولة مرة أخرى.',
    heb: 'לא ניתן לשלוח. נסו שוב.',
    ru: 'Не удалось отправить. Попробуйте ещё раз.',
  },
  bizTypeHair: {
    en: 'Hair & barber',
    ar: 'شعر وحلاقة',
    heb: 'שיער וברבר',
    ru: 'Парикмахерская',
  },
  bizTypeBeauty: {
    en: 'Beauty & nails',
    ar: 'تجميل وأظافر',
    heb: 'יופי וציפורניים',
    ru: 'Красота и ногти',
  },
  bizTypeSpa: {
    en: 'Spa & wellness',
    ar: 'سبا وعناية',
    heb: 'ספא ווולנס',
    ru: 'Спа и wellness',
  },
  bizTypeFitness: {
    en: 'Fitness',
    ar: 'لياقة',
    heb: 'כושר',
    ru: 'Фитнес',
  },
  bizTypeMedical: {
    en: 'Medical clinic',
    ar: 'عيادة طبية',
    heb: 'מרפאה',
    ru: 'Клиника',
  },
  bizTypeDental: {
    en: 'Dental',
    ar: 'أسنان',
    heb: 'רפואת שיניים',
    ru: 'Стоматология',
  },
  bizTypeEducation: {
    en: 'Education',
    ar: 'تعليم',
    heb: 'חינוך',
    ru: 'Образование',
  },
  bizTypePhotography: {
    en: 'Photography',
    ar: 'تصوير',
    heb: 'צילום',
    ru: 'Фотография',
  },
  bizTypeAuto: {
    en: 'Auto',
    ar: 'سيارات',
    heb: 'רכב',
    ru: 'Авто',
  },
  bizTypeFood: {
    en: 'Food & drink',
    ar: 'طعام وشراب',
    heb: 'אוכל ושתייה',
    ru: 'Еда и напитки',
  },
  bizTypeRetail: {
    en: 'Retail',
    ar: 'تجزئة',
    heb: 'קמעונאות',
    ru: 'Розница',
  },
  bizTypeHome: {
    en: 'Home services',
    ar: 'خدمات منزلية',
    heb: 'שירותי בית',
    ru: 'Бытовые услуги',
  },
  bizTypePets: {
    en: 'Pets',
    ar: 'حيوانات أليفة',
    heb: 'חיות מחמד',
    ru: 'Питомцы',
  },
  bizTypeOther: {
    en: 'Other',
    ar: 'أخرى',
    heb: 'אחר',
    ru: 'Другое',
  },

  regAdminTitle: {
    en: 'Business registrations',
    ar: 'طلبات تسجيل الأعمال',
    heb: 'בקשות רישום עסקים',
    ru: 'Регистрации бизнеса',
  },
  regAdminSubtitle: {
    en: 'Pending and submitted registrations from /register',
    ar: 'طلبات التسجيل المعلقة والمُرسلة من /register',
    heb: 'בקשות רישום ממתינות ונשלחות מ-/register',
    ru: 'Ожидающие и отправленные заявки с /register',
  },
  regAdminFilterAll: {
    en: 'All',
    ar: 'الكل',
    heb: 'הכל',
    ru: 'Все',
  },
  regAdminFilterPending: {
    en: 'Pending',
    ar: 'معلّق',
    heb: 'ממתין',
    ru: 'Ожидает',
  },
  regAdminPending: {
    en: 'Pending',
    ar: 'معلّق',
    heb: 'ממתין',
    ru: 'Ожидает',
  },
  regAdminPendingSection: {
    en: 'Pending registrations',
    ar: 'طلبات التسجيل المعلقة',
    heb: 'בקשות רישום ממתינות',
    ru: 'Ожидающие заявки',
  },
  regAdminSubmittedSection: {
    en: 'Submitted registrations',
    ar: 'طلبات التسجيل المُرسلة',
    heb: 'בקשות רישום שנשלחו',
    ru: 'Отправленные заявки',
  },
  regAdminCurrentStep: {
    en: 'Current step',
    ar: 'الخطوة الحالية',
    heb: 'שלב נוכחי',
    ru: 'Текущий шаг',
  },
  regAdminSearchPlaceholder: {
    en: 'Filter by name or phone…',
    ar: 'تصفية حسب الاسم أو الرقم…',
    heb: 'סינון לפי שם או מספר…',
    ru: 'Фильтр по имени или номеру…',
  },
  regAdminEmpty: {
    en: 'No registration submissions found.',
    ar: 'لا توجد طلبات تسجيل.',
    heb: 'לא נמצאו בקשות רישום.',
    ru: 'Заявки не найдены.',
  },
  regAdminStatus: {
    en: 'Status',
    ar: 'الحالة',
    heb: 'סטטוס',
    ru: 'Статус',
  },
  regAdminCreated: {
    en: 'Created',
    ar: 'تاريخ الإنشاء',
    heb: 'נוצר',
    ru: 'Создано',
  },
  regAdminLastEdit: {
    en: 'Last edit',
    ar: 'آخر تعديل',
    heb: 'עריכה אחרונה',
    ru: 'Последнее изменение',
  },
  regAdminSubmittedAt: {
    en: 'Submitted',
    ar: 'تاريخ الإرسال',
    heb: 'נשלח',
    ru: 'Отправлено',
  },
  regAdminDraft: {
    en: 'Draft',
    ar: 'مسودة',
    heb: 'טיוטה',
    ru: 'Черновик',
  },
  regAdminSubmitted: {
    en: 'Submitted',
    ar: 'مُرسل',
    heb: 'נשלח',
    ru: 'Отправлено',
  },
  regAdminUntitled: {
    en: 'Untitled business',
    ar: 'مصلحة بدون اسم',
    heb: 'עסק ללא שם',
    ru: 'Без названия',
  },
  regAdminDetailTitle: {
    en: 'Registration details',
    ar: 'تفاصيل التسجيل',
    heb: 'פרטי הרישום',
    ru: 'Детали регистрации',
  },
  regAdminBack: {
    en: 'Back to list',
    ar: 'العودة للقائمة',
    heb: 'חזרה לרשימה',
    ru: 'Назад к списку',
  },
  regAdminSave: {
    en: 'Save changes',
    ar: 'حفظ التغييرات',
    heb: 'שמירת שינויים',
    ru: 'Сохранить',
  },
  regAdminDelete: {
    en: 'Delete',
    ar: 'حذف',
    heb: 'מחיקה',
    ru: 'Удалить',
  },
  regAdminDeleteTitle: {
    en: 'Delete registration?',
    ar: 'حذف طلب التسجيل؟',
    heb: 'למחוק את הבקשה?',
    ru: 'Удалить заявку?',
  },
  regAdminDeleteConfirm: {
    en: 'This will permanently delete the registration and its uploaded images.',
    ar: 'سيتم حذف طلب التسجيل والصور المرفوعة نهائياً.',
    heb: 'פעולה זו תמחק לצמיתות את הבקשה והתמונות שהועלו.',
    ru: 'Заявка и загруженные изображения будут удалены безвозвратно.',
  },
  regAdminSaved: {
    en: 'Changes saved',
    ar: 'تم حفظ التغييرات',
    heb: 'השינויים נשמרו',
    ru: 'Изменения сохранены',
  },
  regAdminNotFound: {
    en: 'Registration not found',
    ar: 'طلب التسجيل غير موجود',
    heb: 'הבקשה לא נמצאה',
    ru: 'Заявка не найдена',
  },
  regAdminLoadFailed: {
    en: 'Failed to load registration',
    ar: 'فشل تحميل طلب التسجيل',
    heb: 'טעינת הבקשה נכשלה',
    ru: 'Не удалось загрузить заявку',
  },
  regAdminSaveFailed: {
    en: 'Failed to save changes',
    ar: 'فشل حفظ التغييرات',
    heb: 'שמירת השינויים נכשלה',
    ru: 'Не удалось сохранить',
  },
  regAdminDeleteFailed: {
    en: 'Failed to delete registration',
    ar: 'فشل حذف طلب التسجيل',
    heb: 'מחיקת הבקשה נכשלה',
    ru: 'Не удалось удалить',
  },
  regAdminAuthPhone: {
    en: 'Auth phone (login)',
    ar: 'رقم الدخول',
    heb: 'טלפון התחברות',
    ru: 'Телефон входа',
  },
  regAdminMenu: {
    en: 'Registrations',
    ar: 'طلبات التسجيل',
    heb: 'בקשות רישום',
    ru: 'Регистрации',
  },
  regAdminOwner: {
    en: 'Owner',
    ar: 'صاحب المصلحة',
    heb: 'בעלים',
    ru: 'Владелец',
  },
  regAdminNoLogo: {
    en: 'No logo uploaded',
    ar: 'لم يتم رفع شعار',
    heb: 'לא הועלה לוגו',
    ru: 'Логотип не загружен',
  },
  regAdminNoPhotos: {
    en: 'No gallery photos',
    ar: 'لا توجد صور في المعرض',
    heb: 'אין תמונות בגלריה',
    ru: 'Нет фотографий',
  },
  regAdminCopyId: {
    en: 'Copy ID',
    ar: 'نسخ المعرّف',
    heb: 'העתק מזהה',
    ru: 'Копировать ID',
  },
  regAdminCopied: {
    en: 'Copied',
    ar: 'تم النسخ',
    heb: 'הועתק',
    ru: 'Скопировано',
  },
  copiedToClipboard: {
    en: 'Copied to clipboard',
    ar: 'تم النسخ إلى الحافظة',
    heb: 'הועתק ללוח',
    ru: 'Скопировано в буфер обмена',
  },
  regAdminOpen: {
    en: 'Open',
    ar: 'فتح',
    heb: 'פתיחה',
    ru: 'Открыть',
  },
  regAdminView: {
    en: 'View',
    ar: 'عرض',
    heb: 'צפייה',
    ru: 'Просмотр',
  },
  regAdminEdit: {
    en: 'Edit',
    ar: 'تعديل',
    heb: 'עריכה',
    ru: 'Редактировать',
  },
  bizAdminMenu: {
    en: 'Businesses',
    ar: 'الأعمال',
    heb: 'עסקים',
    ru: 'Бизнесы',
  },
  bizAdminTitle: {
    en: 'Businesses',
    ar: 'الأعمال',
    heb: 'עסקים',
    ru: 'Бизнесы',
  },
  bizAdminSaved: {
    en: 'Changes saved',
    ar: 'تم حفظ التغييرات',
    heb: 'השינויים נשמרו',
    ru: 'Изменения сохранены',
  },
  bizAdminSubtitle: {
    en: 'Browse and manage all registered businesses',
    ar: 'تصفح وإدارة جميع الأعمال المسجلة',
    heb: 'עיון וניהול של כל העסקים הרשומים',
    ru: 'Просмотр и управление всеми зарегистрированными бизнесами',
  },
  bizAdminSearchPlaceholder: {
    en: 'Search by name, phone, address, or ID…',
    ar: 'ابحث بالاسم أو الهاتف أو العنوان أو المعرّف…',
    heb: 'חיפוש לפי שם, טלפון, כתובת או מזהה…',
    ru: 'Поиск по имени, телефону, адресу или ID…',
  },
  bizAdminFilterAll: {
    en: 'All',
    ar: 'الكل',
    heb: 'הכל',
    ru: 'Все',
  },
  bizAdminFilterYes: {
    en: 'Yes',
    ar: 'نعم',
    heb: 'כן',
    ru: 'Да',
  },
  bizAdminFilterNo: {
    en: 'No',
    ar: 'لا',
    heb: 'לא',
    ru: 'Нет',
  },
  bizAdminFilterDeactivated: {
    en: 'Status',
    ar: 'الحالة',
    heb: 'סטטוס',
    ru: 'Статус',
  },
  bizAdminFilterWebUser: {
    en: 'Web user',
    ar: 'مستخدم ويب',
    heb: 'משתמש ווב',
    ru: 'Веб-пользователь',
  },
  bizAdminFilterPrivateBotInactive: {
    en: 'Private bot status',
    ar: 'حالة البوت الخاص',
    heb: 'סטטוס בוט פרטי',
    ru: 'Статус приватного бота',
  },
  bizAdminStatusActive: {
    en: 'Active',
    ar: 'فعال',
    heb: 'פעיל',
    ru: 'Активен',
  },
  bizAdminStatusInactive: {
    en: 'Inactive',
    ar: 'غير فعال',
    heb: 'לא פעיל',
    ru: 'Неактивен',
  },
  bizAdminResultsCount: {
    en: '{count} of {total} businesses',
    ar: '{count} من {total} أعمال',
    heb: '{count} מתוך {total} עסקים',
    ru: '{count} из {total} бизнесов',
  },
  bizAdminEmpty: {
    en: 'No businesses match your filters',
    ar: 'لا توجد أعمال تطابق الفلاتر',
    heb: 'לא נמצאו עסקים התואמים לסינון',
    ru: 'Нет бизнесов по выбранным фильтрам',
  },
  bizAdminBusinessId: {
    en: 'Business ID',
    ar: 'معرّف العمل',
    heb: 'מזהה עסק',
    ru: 'ID бизнеса',
  },
  bizAdminNotFound: {
    en: 'Business not found',
    ar: 'العمل غير موجود',
    heb: 'העסק לא נמצא',
    ru: 'Бизнес не найден',
  },
  bizAdminLoadFailed: {
    en: 'Failed to load business',
    ar: 'فشل تحميل العمل',
    heb: 'טעינת העסק נכשלה',
    ru: 'Не удалось загрузить бизнес',
  },
  bizAdminBackToList: {
    en: 'Back to businesses',
    ar: 'العودة إلى الأعمال',
    heb: 'חזרה לעסקים',
    ru: 'Назад к списку',
  },
  bizAdminStreet: {
    en: 'Street address',
    ar: 'عنوان الشارع',
    heb: 'כתובת',
    ru: 'Адрес',
  },
  bizAdminWebsite: {
    en: 'Website',
    ar: 'الموقع',
    heb: 'אתר',
    ru: 'Сайт',
  },
  bizAdminInstagram: {
    en: 'Instagram',
    ar: 'إنستغرام',
    heb: 'אינסטגרם',
    ru: 'Instagram',
  },
  bizAdminFacebook: {
    en: 'Facebook',
    ar: 'فيسبوك',
    heb: 'פייסבוק',
    ru: 'Facebook',
  },
  bizAdminFeaturesTitle: {
    en: 'Features',
    ar: 'الميزات',
    heb: 'תכונות',
    ru: 'Функции',
  },
  bizAdminFeaturesSubtitle: {
    en: 'Enable or disable features for this business',
    ar: 'تفعيل أو تعطيل الميزات لهذا العمل',
    heb: 'הפעלה או השבתה של תכונות לעסק זה',
    ru: 'Включение и отключение функций для этого бизнеса',
  },
  bizAdminFeatureBookAgain: {
    en: 'Book again',
    ar: 'احجز مجدداً',
    heb: 'הזמנה חוזרת',
    ru: 'Повторная запись',
  },
  bizAdminFeatureMultiBook: {
    en: 'Multi book',
    ar: 'حجز متعدد',
    heb: 'הזמנה מרובה',
    ru: 'Множественная запись',
  },
  bizAdminFeatureMultiAptBook: {
    en: 'Multi appointment book',
    ar: 'حجز مواعيد متعددة',
    heb: 'הזמנת תורים מרובים',
    ru: 'Запись нескольких услуг',
  },
  bizAdminFeaturePayments: {
    en: 'Payments',
    ar: 'المدفوعات',
    heb: 'תשלומים',
    ru: 'Платежи',
  },
  bizAdminFeatureAppointments: {
    en: 'Appointments',
    ar: 'المواعيد',
    heb: 'תורים',
    ru: 'Записи',
  },
  bizAdminFeaturePaymentReminders: {
    en: 'Payment reminders',
    ar: 'تذكيرات الدفع',
    heb: 'תזכורות תשלום',
    ru: 'Напоминания об оплате',
  },
  bizAdminFeatureSkipStaff: {
    en: 'Skip staff selection',
    ar: 'تخطي اختيار الموظف',
    heb: 'דילוג על בחירת צוות',
    ru: 'Пропуск выбора сотрудника',
  },
  bizAdminFeatureUserFeedback: {
    en: 'User feedback',
    ar: 'ملاحظات المستخدم',
    heb: 'משוב משתמשים',
    ru: 'Отзывы пользователей',
  },
  bizAdminFeatureRestrictedScheduling: {
    en: 'Restricted scheduling',
    ar: 'جدولة مقيدة',
    heb: 'תזמון מוגבל',
    ru: 'Ограниченное планирование',
  },
  bizAdminFeatureReminders: {
    en: 'Reminders',
    ar: 'التذكيرات',
    heb: 'תזכורות',
    ru: 'Напоминания',
  },
  bizAdminFeatureBookingChangesUpdates: {
    en: 'Booking changes updates',
    ar: 'تحديثات تغييرات الحجز',
    heb: 'עדכוני שינויי הזמנה',
    ru: 'Обновления изменений записи',
  },
  bizAdminFeatureHideDuration: {
    en: 'Hide duration',
    ar: 'إخفاء المدة',
    heb: 'הסתרת משך',
    ru: 'Скрыть длительность',
  },
  bizAdminFeatureNotesImageSupport: {
    en: 'Notes image upload',
    ar: 'رفع صورة للملاحظات',
    heb: 'העלאת תמונה להערות',
    ru: 'Загрузка изображений в заметки',
  },
  bizAdminFeatureWaitlist: {
    en: 'Waitlist',
    ar: 'قائمة الانتظار',
    heb: 'רשימת המתנה',
    ru: 'Лист ожидания',
  },
  bizAdminFeaturePunchCards: {
    en: 'Punch cards',
    ar: 'بطاقات الختم',
    heb: 'כרטיסיות ניקוב',
    ru: 'Карты посещений',
  },
  bizAdminFeatureGenericMessages: {
    en: 'Generic messages',
    ar: 'رسائل عامة',
    heb: 'הודעות כלליות',
    ru: 'Общие сообщения',
  },
  bizAdminAdditionalConfigsTitle: {
    en: 'Additional configs',
    ar: 'إعدادات إضافية',
    heb: 'הגדרות נוספות',
    ru: 'Доп. настройки',
  },
  bizAdminAdditionalConfigsSubtitle: {
    en: 'Toggle extra business behavior flags',
    ar: 'تفعيل أو تعطيل إعدادات سلوك إضافية للعمل',
    heb: 'הפעלה או השבתה של דגלי התנהגות נוספים לעסק',
    ru: 'Включение и отключение дополнительных флагов бизнеса',
  },
  bizAdminConfigSupportAnyStaff: {
    en: 'Support any staff',
    ar: 'دعم خيار أي موظف',
    heb: 'תמיכה בבחירת כל איש צוות',
    ru: 'Поддержка любого сотрудника',
  },
  bizAdminConfigSupportAnyStaffHint: {
    en: 'Allows users to select “any” from the staff options',
    ar: 'يسمح للمستخدمين باختيار "أي موظف" من خيارات الموظفين',
    heb: 'מאפשר למשתמשים לבחור "כל אחד" מתוך אפשרויות הצוות',
    ru: 'Позволяет пользователям выбрать «любой» из сотрудников',
  },
  bizAdminConfigSupportSlotCapacity: {
    en: 'Support slot capacity',
    ar: 'دعم سعة الفترة',
    heb: 'תמיכה בקיבולת משבצת',
    ru: 'Поддержка вместимости слота',
  },
  bizAdminConfigSupportSlotCapacityHint: {
    en: 'Maximum number of events that can share the same start and end time. Leave empty to disable.',
    ar: 'العدد الأقصى للأحداث التي يمكن أن تتشارك نفس وقت البداية والنهاية. اتركه فارغًا للتعطيل.',
    heb: 'מספר האירועים המרבי שיכולים לחלוק את אותם זמני התחלה וסיום. השאירו ריק כדי לכבות.',
    ru: 'Максимальное число событий с одинаковым временем начала и конца. Оставьте пустым, чтобы отключить.',
  },
  bizAdminConfigNotifyHelpRequests: {
    en: 'Notify help requests',
    ar: 'إشعار طلبات المساعدة',
    heb: 'התראות על בקשות עזרה',
    ru: 'Уведомления о запросах помощи',
  },
  bizAdminConfigNotifyHelpRequestsHint: {
    en: 'Sends staff a notification when users ask for help',
    ar: 'يرسل إشعارًا للموظفين عندما يطلب المستخدمون المساعدة',
    heb: 'שולח לצוות התראה כאשר משתמשים מבקשים עזרה',
    ru: 'Отправляет сотрудникам уведомление, когда пользователи просят помощь',
  },
  bizAdminConfigSendBookingConfirmation: {
    en: 'Send booking confirmation message',
    ar: 'إرسال رسالة تأكيد الحجز',
    heb: 'שליחת הודעת אישור הזמנה',
    ru: 'Отправлять сообщение подтверждения записи',
  },
  bizAdminConfigSendBookingConfirmationHint: {
    en: 'Sends a booking confirmed message when the user books from web',
    ar: 'يرسل رسالة تأكيد عند الحجز من الويب',
    heb: 'שולח הודעת אישור הזמנה כאשר המשתמש מזמין מהאתר',
    ru: 'Отправляет подтверждение, когда пользователь записывается с сайта',
  },
  bizAdminConfigSendFilledQuestionnaire: {
    en: 'Send filled questionnaire template',
    ar: 'إرسال قالب الاستبيان المعبأ',
    heb: 'שליחת תבנית שאלון שמולא',
    ru: 'Отправлять шаблон заполненной анкеты',
  },
  bizAdminConfigSendFilledQuestionnaireHint: {
    en: 'Sends a template when a user fills a questionnaire',
    ar: 'يرسل قالبًا عندما يعبئ المستخدم استبيانًا',
    heb: 'שולח תבנית כאשר משתמש ממלא שאלון',
    ru: 'Отправляет шаблон, когда пользователь заполняет анкету',
  },
  bizAdminRestrictedSchedulingDefaultTitle: {
    en: 'Restricted scheduling default',
    ar: 'الافتراضي للجدولة المقيّدة',
    heb: 'ברירת מחדל לתזמון מוגבל',
    ru: 'Значение по умолчанию для ограниченного расписания',
  },
  bizAdminRestrictedSchedulingDefaultSubtitle: {
    en: 'For customers with no personal scheduling access record. Requires the restricted scheduling feature.',
    ar: 'للعملاء الذين لا يملكون إعدادًا شخصيًا. يتطلب ميزة الجدولة المقيّدة.',
    heb: 'ללקוחות ללא רשומת גישה אישית. דורש את תכונת התזמון המוגבל.',
    ru: 'Для клиентов без персональной записи. Нужна функция ограниченного расписания.',
  },
  bizAdminRestrictedSchedulingDefaultUse: {
    en: 'Use custom default for new customers',
    ar: 'استخدام افتراضي مخصص للعملاء الجدد',
    heb: 'השתמש בברירת מחדל מותאמת ללקוחות חדשים',
    ru: 'Свой дефолт для новых клиентов',
  },
  bizAdminRestrictedSchedulingDefaultUseHint: {
    en: 'When off, restricted appointment types stay blocked until you allow each customer manually.',
    ar: 'عند الإيقاف، تبقى المواعيد المقيّدة محظورة حتى تسمح لكل عميل يدويًا.',
    heb: 'כשכבוי, סוגי תורים מוגבלים נשארים חסומים עד שתאשר לכל לקוח בנפרד.',
    ru: 'Если выключено, ограниченные типы записи заблокированы, пока вы не разрешите вручную.',
  },
  bizAdminRestrictedSchedulingDefaultEnableAll: {
    en: 'Allow all appointment types by default',
    ar: 'السماح بكل أنواع المواعيد افتراضيًا',
    heb: 'אפשר את כל סוגי התורים כברירת מחדל',
    ru: 'Разрешить все типы записи по умолчанию',
  },
  bizAdminRestrictedSchedulingDefaultEnableAllHint: {
    en: 'Same as “Allow all appointments” on a customer profile',
    ar: 'مثل «السماح بكل المواعيد» في ملف العميل',
    heb: 'כמו «אפשר את כל התורים» בפרופיל לקוח',
    ru: 'Как «Разрешить все записи» в профиле клиента',
  },
  bizAdminRestrictedSchedulingDefaultPerApt: {
    en: 'Choose which appointment types are allowed by default:',
    ar: 'اختر أنواع المواعيد المسموحة افتراضيًا:',
    heb: 'בחר אילו סוגי תורים מותרים כברירת מחדל:',
    ru: 'Какие типы записи разрешены по умолчанию:',
  },
  bizAdminRestrictedSchedulingDefaultNoApts: {
    en: 'No appointment types configured for this business.',
    ar: 'لا توجد أنواع مواعيد مُعدّة لهذا العمل.',
    heb: 'לא הוגדרו סוגי תורים לעסק זה.',
    ru: 'Для этого бизнеса не настроены типы записи.',
  },
  bizAdminRestrictedSchedulingFeatureOff: {
    en: 'Turn on “Restricted scheduling” in the Features tab to use this default.',
    ar: 'فعّل «الجدولة المقيّدة» في تبويب الميزات لاستخدام هذا الافتراضي.',
    heb: 'הפעל «תזמון מוגבל» בלשונית תכונות כדי להשתמש בברירת מחדל זו.',
    ru: 'Включите «Ограниченное расписание» на вкладке функций.',
  },
  bizAdminReminderConfigTitle: {
    en: 'Event reminder',
    ar: 'تذكير الحدث',
    heb: 'תזכורת אירוע',
    ru: 'Напоминание о событии',
  },
  bizAdminReminderConfigSubtitle: {
    en: 'Configure booking reminder timing and delivery',
    ar: 'ضبط توقيت وإرسال تذكيرات الحجز',
    heb: 'הגדרת תזמון ושליחה של תזכורות הזמנה',
    ru: 'Настройка времени и отправки напоминаний о записи',
  },
  bizAdminReminderHourOfDay: {
    en: 'Hour of day',
    ar: 'ساعة اليوم',
    heb: 'שעה ביום',
    ru: 'Час дня',
  },
  bizAdminReminderDaysBefore: {
    en: 'Days before booking',
    ar: 'عدد الأيام قبل الحجز',
    heb: 'ימים לפני ההזמנה',
    ru: 'Дней до записи',
  },
  bizAdminReminderDaysAfterFirst: {
    en: 'Days after first reminder',
    ar: 'عدد الأيام بعد التذكير الأول',
    heb: 'ימים אחרי התזכורת הראשונה',
    ru: 'Дней после первого напоминания',
  },
  bizAdminReminderMinsBefore: {
    en: 'Minutes before booking',
    ar: 'دقائق قبل الحجز',
    heb: 'דקות לפני ההזמנה',
    ru: 'Минут до записи',
  },
  bizAdminReminderShabatFriendly: {
    en: 'Shabbat friendly',
    ar: 'مراعٍ للسبت',
    heb: 'ידידותי לשבת',
    ru: 'Учитывать шаббат',
  },
  bizAdminReminderShabatFriendlyHint: {
    en: 'Default is off',
    ar: 'الإعداد الافتراضي معطّل',
    heb: 'ברירת המחדל כבויה',
    ru: 'По умолчанию выключено',
  },
  bizAdminReminderIgnoreConfirmation: {
    en: 'Ignore confirmation',
    ar: 'تجاهل التأكيد',
    heb: 'התעלם מאישור',
    ru: 'Игнорировать подтверждение',
  },
  bizAdminReminderIgnoreConfirmationHint: {
    en: 'Resend even if the user already confirmed arrival',
    ar: 'إعادة الإرسال حتى إذا أكد المستخدم الحضور',
    heb: 'שליחה מחדש גם אם המשתמש כבר אישר הגעה',
    ru: 'Отправлять повторно, даже если пользователь подтвердил приход',
  },
  bizAdminReminderOnlyBeforeBooking: {
    en: 'Send only before booking',
    ar: 'الإرسال قبل الحجز فقط',
    heb: 'שליחה רק לפני ההזמנה',
    ru: 'Отправлять только перед записью',
  },
  bizAdminReminderOnlyBeforeBookingHint: {
    en: 'If yes, send only at the minutes-before time',
    ar: 'إذا نعم، يُرسل فقط في وقت الدقائق قبل الحجز',
    heb: 'אם כן, יישלח רק בזמן הדקות לפני ההזמנה',
    ru: 'Если да, отправляется только за указанное число минут',
  },
  bizAdminReminderWithoutCancelBtn: {
    en: 'Reminder without cancel button',
    ar: 'تذكير بدون زر إلغاء',
    heb: 'תזכורת בלי כפתור ביטול',
    ru: 'Напоминание без кнопки отмены',
  },
  bizAdminReminderWithoutCancelBtnHint: {
    en: 'Send the reminder without a cancel button',
    ar: 'إرسال التذكير بدون زر إلغاء',
    heb: 'שליחת התזכורת בלי כפתור ביטול',
    ru: 'Отправлять напоминание без кнопки отмены',
  },
  bizAdminLanguagesTitle: {
    en: 'Supported languages',
    ar: 'اللغات المدعومة',
    heb: 'שפות נתמכות',
    ru: 'Поддерживаемые языки',
  },
  bizAdminLanguagesSubtitle: {
    en: 'Choose which languages this business supports',
    ar: 'اختر اللغات التي يدعمها هذا العمل',
    heb: 'בחרו אילו שפות העסק תומך בהן',
    ru: 'Выберите языки, которые поддерживает этот бизнес',
  },
  bizAdminLangEnglish: {
    en: 'English',
    ar: 'الإنجليزية',
    heb: 'אנגלית',
    ru: 'Английский',
  },
  bizAdminLangArabic: {
    en: 'Arabic',
    ar: 'العربية',
    heb: 'ערבית',
    ru: 'Арабский',
  },
  bizAdminLangHebrew: {
    en: 'Hebrew',
    ar: 'العبرية',
    heb: 'עברית',
    ru: 'Иврит',
  },
  bizAdminLangRussian: {
    en: 'Russian',
    ar: 'الروسية',
    heb: 'רוסית',
    ru: 'Русский',
  },
  bizAdminSchedulingWindowTitle: {
    en: 'Scheduling window',
    ar: 'نافذة الجدولة',
    heb: 'חלון תזמון',
    ru: 'Окно записи',
  },
  bizAdminSchedulingWindowSubtitle: {
    en: 'Number of days in the future that are open for booking',
    ar: 'عدد الأيام المستقبلية المتاحة للحجز',
    heb: 'מספר הימים בעתיד הפתוחים להזמנה',
    ru: 'Сколько дней вперед открыто для записи',
  },
  bizAdminSchedulingWindowDays: {
    en: 'Days open for booking',
    ar: 'عدد الأيام المتاحة للحجز',
    heb: 'ימים פתוחים להזמנה',
    ru: 'Дней открыто для записи',
  },
  bizAdminMenuConfigsTitle: {
    en: 'Menu configs',
    ar: 'إعدادات القائمة',
    heb: 'הגדרות תפריט',
    ru: 'Настройки меню',
  },
  bizAdminMenuConfigsSubtitle: {
    en: 'Controls the main WhatsApp menu customers see',
    ar: 'يتحكم بقائمة واتساب الرئيسية التي يراها العملاء',
    heb: 'שולט בתפריט הוואטסאפ הראשי שהלקוחות רואים',
    ru: 'Управляет главным меню WhatsApp, которое видят клиенты',
  },
  bizAdminMenuReschedule: {
    en: 'Reschedule enabled',
    ar: 'تفعيل إعادة الجدولة',
    heb: 'שינוי מועד מופעל',
    ru: 'Перенос включен',
  },
  bizAdminMenuSchedule: {
    en: 'Schedule enabled',
    ar: 'تفعيل الجدولة',
    heb: 'קביעת תור מופעלת',
    ru: 'Запись включена',
  },
  bizAdminMenuCallMeBack: {
    en: 'Call me back enabled',
    ar: 'تفعيل اتصل بي لاحقًا',
    heb: 'חזרה אליי מופעלת',
    ru: 'Перезвоните мне включено',
  },
  bizAdminMenuReferral: {
    en: 'Referral enabled',
    ar: 'تفعيل الإحالات',
    heb: 'הפניות מופעלות',
    ru: 'Рефералы включены',
  },
  bizAdminMenuContactInfoDisabled: {
    en: 'Contact info disabled',
    ar: 'تعطيل معلومات الاتصال',
    heb: 'פרטי קשר מושבתים',
    ru: 'Контакты отключены',
  },
  bizAdminMenuLocationPublic: {
    en: 'Location public',
    ar: 'الموقع عام',
    heb: 'מיקום ציבורי',
    ru: 'Адрес публичный',
  },
  bizAdminMenuShop: {
    en: 'Shop enabled',
    ar: 'تفعيل المتجر',
    heb: 'חנות מופעלת',
    ru: 'Магазин включен',
  },
  bizAdminUnset: {
    en: 'Unset',
    ar: 'غير محدد',
    heb: 'לא מוגדר',
    ru: 'Не задано',
  },
  bizAdminNoStats: {
    en: 'No stats available for this business yet',
    ar: 'لا توجد إحصائيات لهذا العمل بعد',
    heb: 'אין עדיין סטטיסטיקות לעסק זה',
    ru: 'Для этого бизнеса пока нет статистики',
  },
  bizAdminNoReviews: {
    en: 'No reviews for this business yet',
    ar: 'لا توجد تقييمات لهذا العمل بعد',
    heb: 'אין עדיין ביקורות לעסק זה',
    ru: 'Для этого бизнеса пока нет отзывов',
  },
  bizAdminNoStaff: {
    en: 'No staff members for this business yet',
    ar: 'لا يوجد موظفون لهذا العمل بعد',
    heb: 'אין עדיין אנשי צוות לעסק זה',
    ru: 'Для этого бизнеса пока нет сотрудников',
  },
  bizAdminNoServices: {
    en: 'No services for this business yet',
    ar: 'لا توجد خدمات لهذا العمل بعد',
    heb: 'אין עדיין שירותים לעסק זה',
    ru: 'Для этого бизнеса пока нет услуг',
  },
  bizAdminServiceId: {
    en: 'Service ID',
    ar: 'معرّف الخدمة',
    heb: 'מזהה שירות',
    ru: 'ID услуги',
  },
  bizAdminPublicSlug: {
    en: 'Public slug',
    ar: 'المعرّف العام',
    heb: 'מזהה ציבורי',
    ru: 'Публичный slug',
  },
  bizAdminPublicMappingNumber: {
    en: 'Mapping number',
    ar: 'رقم الربط',
    heb: 'מספר מיפוי',
    ru: 'Номер маппинга',
  },
  bizAdminNoPublicMapping: {
    en: 'No public mapping',
    ar: 'لا يوجد ربط عام',
    heb: 'אין מיפוי ציבורי',
    ru: 'Нет публичного маппинга',
  },
  uid: {
    en: 'UID',
    ar: 'المعرّف',
    heb: 'UID',
    ru: 'UID',
  },
  landingPageImages: {
    en: 'Landing Page Images',
    ar: 'صور صفحة الحجز',
    heb: 'תמונות דף הנחיתה',
    ru: 'Изображения страницы бронирования',
  },
  landingPageImagesDesc: {
    en: 'Manage the cover images shown on your booking page. Drag to reorder.',
    ar: 'إدارة صور الغلاف المعروضة في صفحة الحجز. اسحب لإعادة الترتيب.',
    heb: 'נהלו תמונות הכיסוי שמוצגות בדף ההזמנות. גררו לשינוי סדר.',
    ru: 'Управляйте обложками на странице бронирования. Перетаскивайте для изменения порядка.',
  },
  landingPageUrl: {
    en: 'Your booking page',
    ar: 'صفحة الحجز الخاصة بك',
    heb: 'דף ההזמנות שלך',
    ru: 'Ваша страница бронирования',
  },
  coverImagesEmpty: {
    en: 'No cover images yet. Upload images to display on your booking page.',
    ar: 'لا توجد صور غلاف بعد. ارفع صورًا لعرضها في صفحة الحجز.',
    heb: 'אין עדיין תמונות כיסוי. העלו תמונות להצגה בדף ההזמנות.',
    ru: 'Обложек пока нет. Загрузите изображения для страницы бронирования.',
  },
  addCoverImages: {
    en: 'Drop images here or click to upload',
    ar: 'اسحب الصور هنا أو انقر للرفع',
    heb: 'גררו תמונות לכאן או לחצו להעלאה',
    ru: 'Перетащите изображения сюда или нажмите для загрузки',
  },
  coverImagesHint: {
    en: 'Up to 8 images.',
    ar: 'حتى 8 صور.',
    heb: 'עד 8 תמונות.',
    ru: 'До 8 изображений.',
  },
  coverImagesMaxReached: {
    en: 'Maximum number of cover images reached.',
    ar: 'تم الوصول إلى الحد الأقصى لعدد صور الغلاف.',
    heb: 'הגעתם למספר המקסימלי של תמונות כיסוי.',
    ru: 'Достигнуто максимальное количество обложек.',
  },
  deleteCoverImageWarning: {
    en: 'Are you sure you want to delete this cover image?',
    ar: 'هل أنت متأكد من حذف صورة الغلاف هذه؟',
    heb: 'האם למחוק תמונת כיסוי זו?',
    ru: 'Удалить это изображение обложки?',
  },
  businessDescription: {
    en: 'Business description',
    ar: 'وصف المصلحة',
    heb: 'תיאור העסק',
    ru: 'Описание бизнеса',
  },
  businessDescriptionHint: {
    en: 'Shown on your booking landing page.',
    ar: 'يظهر في صفحة الحجز.',
    heb: 'מוצג בדף הנחיתה להזמנת תורים.',
    ru: 'Отображается на странице записи.',
  },
  businessDescriptionPlaceholder: {
    en: 'Tell people about your business',
    ar: 'أخبر الناس عن مصلحتك',
    heb: 'ספרו לאנשים על העסק',
    ru: 'Расскажите о вашем бизнесе',
  },
  businessDescriptionSaved: {
    en: 'Business description saved',
    ar: 'تم حفظ وصف المصلحة',
    heb: 'תיאור העסק נשמר',
    ru: 'Описание бизнеса сохранено',
  },
  recordPayment: {
    en: 'Record payment',
    ar: 'تسجيل دفعة',
    heb: 'רישום תשלום',
    ru: 'Записать оплату',
  },
  editPayment: {
    en: 'Edit payment',
    ar: 'تعديل الدفعة',
    heb: 'עריכת תשלום',
    ru: 'Изменить оплату',
  },
  paymentAmountExceedsServicePrice: {
    en: 'The amount entered is higher than the service price',
    ar: 'المبلغ المدخل أعلى من سعر الخدمة',
    heb: 'הסכום שהוזן גבוה ממחיר השירות',
    ru: 'Введённая сумма превышает цену услуги',
  },
  paymentAmount: {
    en: 'Amount',
    ar: 'المبلغ',
    heb: 'סכום',
    ru: 'Сумма',
  },
  paymentAmountFullPrice: {
    en: 'Full price',
    ar: 'السعر الكامل',
    heb: 'מחיר מלא',
    ru: 'Полная цена',
  },
  paymentMethod: {
    en: 'Payment method',
    ar: 'طريقة الدفع',
    heb: 'אמצעי תשלום',
    ru: 'Способ оплаты',
  },
  paymentMethodTransfer: {
    en: 'Transfer',
    ar: 'تحويل',
    heb: 'העברה',
    ru: 'Перевод',
  },
  paymentMethodBit: {
    en: 'Bit',
    ar: 'Bit',
    heb: 'Bit',
    ru: 'Bit',
  },
  paymentMethodCash: {
    en: 'Cash',
    ar: 'نقداً',
    heb: 'מזומן',
    ru: 'Наличные',
  },
  paymentMethodCard: {
    en: 'Visa',
    ar: 'فيزا',
    heb: 'ויזה',
    ru: 'Visa',
  },
  paymentType: {
    en: 'Type',
    ar: 'النوع',
    heb: 'סוג',
    ru: 'Тип',
  },
  removePayment: {
    en: 'Remove',
    ar: 'حذف',
    heb: 'הסר',
    ru: 'Удалить',
  },
  systemTagsMenu: {
    en: 'System tags',
    ar: 'وسوم النظام',
    heb: 'תגיות מערכת',
    ru: 'Системные теги',
  },
  systemTagsTitle: {
    en: 'System tags',
    ar: 'وسوم النظام',
    heb: 'תגיות מערכת',
    ru: 'Системные теги',
  },
  systemTagsSubtitle: {
    en: 'Shared tags used across all businesses for automatic user tagging',
    ar: 'وسوم مشتركة لجميع الأعمال تُستخدم للوسم التلقائي للمستخدمين',
    heb: 'תגיות משותפות לכל העסקים לסימון משתמשים אוטומטי',
    ru: 'Общие теги для всех бизнесов, используемые для автотегирования',
  },
  systemTagsAdd: {
    en: 'Add system tag',
    ar: 'إضافة وسم نظام',
    heb: 'הוספת תגית מערכת',
    ru: 'Добавить системный тег',
  },
  systemTagsEdit: {
    en: 'Edit system tag',
    ar: 'تعديل وسم النظام',
    heb: 'עריכת תגית מערכת',
    ru: 'Изменить системный тег',
  },
  systemTagsEmpty: {
    en: 'No system tags yet',
    ar: 'لا توجد وسوم نظام بعد',
    heb: 'אין עדיין תגיות מערכת',
    ru: 'Системных тегов пока нет',
  },
  systemTagsName: {
    en: 'Name',
    ar: 'الاسم',
    heb: 'שם',
    ru: 'Название',
  },
  systemTagsId: {
    en: 'ID',
    ar: 'المعرّف',
    heb: 'מזהה',
    ru: 'ID',
  },
  systemTagsColor: {
    en: 'Color',
    ar: 'اللون',
    heb: 'צבע',
    ru: 'Цвет',
  },
  systemTagsAssignment: {
    en: 'Assignment',
    ar: 'التعيين',
    heb: 'שיוך',
    ru: 'Назначение',
  },
  systemTagsHidden: {
    en: 'Hidden',
    ar: 'مخفي',
    heb: 'מוסתר',
    ru: 'Скрытый',
  },
  systemTagsCanAdd: {
    en: 'Can add to users',
    ar: 'يمكن إضافته للمستخدمين',
    heb: 'ניתן להוסיף למשתמשים',
    ru: 'Можно назначать пользователям',
  },
  systemTagsCanAddHint: {
    en: 'Staff can assign this tag to a customer from the dashboard',
    ar: 'يمكن للموظفين تعيين هذا الوسم للعميل من لوحة التحكم',
    heb: 'צוות יכול לשייך תגית זו ללקוח מהלוח',
    ru: 'Сотрудники могут назначить этот тег клиенту в панели',
  },
  systemTagsCanRemove: {
    en: 'Can remove from users',
    ar: 'يمكن إزالته من المستخدمين',
    heb: 'ניתן להסיר ממשתמשים',
    ru: 'Можно снимать с пользователей',
  },
  systemTagsCanRemoveHint: {
    en: 'Staff can take this tag off a customer from the dashboard',
    ar: 'يمكن للموظفين إزالة هذا الوسم من العميل في لوحة التحكم',
    heb: 'צוות יכול להסיר תגית זו מלקוח מהלוח',
    ru: 'Сотрудники могут снять этот тег с клиента в панели',
  },
  systemTagsInvalidId: {
    en: 'ID must start with a letter and contain only letters, numbers, _ or -',
    ar: 'يجب أن يبدأ المعرّف بحرف ويحتوي فقط على أحرف وأرقام و _ أو -',
    heb: 'המזהה חייב להתחיל באות ולהכיל רק אותיות, ספרות, _ או -',
    ru: 'ID должен начинаться с буквы и содержать только буквы, цифры, _ или -',
  },
  systemTagsDuplicateId: {
    en: 'A system tag with this ID already exists',
    ar: 'وسم نظام بهذا المعرّف موجود بالفعل',
    heb: 'תגית מערכת עם המזהה הזה כבר קיימת',
    ru: 'Системный тег с таким ID уже существует',
  },
  systemTagsNameRequired: {
    en: 'Enter a name in at least one language',
    ar: 'أدخل اسمًا بلغة واحدة على الأقل',
    heb: 'הזינו שם בשפה אחת לפחות',
    ru: 'Укажите название хотя бы на одном языке',
  },
  systemTagsSaved: {
    en: 'System tag saved',
    ar: 'تم حفظ وسم النظام',
    heb: 'תגית המערכת נשמרה',
    ru: 'Системный тег сохранён',
  },
  systemTagsSaveFailed: {
    en: 'Failed to save system tag',
    ar: 'فشل حفظ وسم النظام',
    heb: 'שמירת תגית המערכת נכשלה',
    ru: 'Не удалось сохранить системный тег',
  },
  systemTagsDeleted: {
    en: 'System tag deleted',
    ar: 'تم حذف وسم النظام',
    heb: 'תגית המערכת נמחקה',
    ru: 'Системный тег удалён',
  },
  systemTagsDeleteFailed: {
    en: 'Failed to delete system tag',
    ar: 'فشل حذف وسم النظام',
    heb: 'מחיקת תגית המערכת נכשלה',
    ru: 'Не удалось удалить системный тег',
  },
  systemTagsDeleteWarning: {
    en: 'Delete this system tag? It will no longer be available across businesses.',
    ar: 'حذف وسم النظام هذا؟ لن يعود متاحًا عبر الأعمال.',
    heb: 'למחוק את תגית המערכת? היא לא תהיה זמינה יותר בכל העסקים.',
    ru: 'Удалить этот системный тег? Он больше не будет доступен во всех бизнесах.',
  },
  refundNonManagedOnCancel: {
    en: 'Refund the customer for {amount}',
    ar: 'ترجيع المبلغ للزبون {amount}',
    heb: 'החזר ללקוח/ה על {amount}',
    ru: 'Вернуть клиенту {amount}',
  }
}
